import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
//import FormControlLabel from '@material-ui/core/FormControlLabel';
//import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Button from "@material-ui/core/Button";
import { deleteAVehicle, loadVehiclesData, saveAVehicle, updateAVehicle } from "../../redux/modules/vehicle";
import { saveATowjob, updateATowjob, clearTowErrorMsg, uploadATowPicture } from "../../redux/modules/towjob";
import { saveAPolicenotice, updateAPolicenoticePath } from "../../redux/modules/policenotice";
import { saveAFax } from "../../redux/modules/fax";
import { saveAEmail } from "../../redux/modules/email";
//import startcase from 'lodash.startcase';
//import {deleteAUser, loadUsersData, saveAUser, updateAUser, loadSingleUserData} from "../../redux/modules/user";
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import Tooltip from '@material-ui/core/Tooltip';
//import { Link } from 'react-router';
//import {loadCamerasData} from "../../redux/modules/camera";
import { withStyles } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
//import CardUserInformation from "./CardUserInformation";
//import {loadLocationsData} from "../../redux/modules/location";
import Divider from '@material-ui/core/Divider';
import moment from 'moment';
import './calendarfiles/input-moment.less';
import './calendarfiles/app.less';
import { deleteAPolice, loadPoliceData, saveAPolice, updateAPolice } from "../../redux/modules/police";
import { loadTowEmailsDataWithFilter } from "../../redux/modules/email";
import { loadTowFaxsDataWithFilter } from "../../redux/modules/fax";

import { loadCompanysData, selectACompany } from "../../redux/modules/company";
import { decodeVin } from "../../redux/modules/vin";
import { loadCompanypropertysData } from "../../redux/modules/companyproperty";
import { loadStoragelotsData } from "../../redux/modules/storagelot";
import { loadPdfFile } from "../../redux/modules/pdf";
import * as MainConstants from "../../utils/MainConstants";
import { loadSingleUserData, loadUsersData } from "../../redux/modules/user";
import ListItemText from '@material-ui/core/ListItemText';
import { deepPurple } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
//import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import Switch from '@material-ui/core/Switch';
//import InputLabel from '@material-ui/core/InputLabel';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
//import { Document, Page } from "react-pdf";
import { Document, Page } from "react-pdf";
import * as SockJS from "sockjs-client";
import * as Stomp from "stomp-websocket";
//import FormLabel from '@material-ui/core/FormLabel';
//import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import { DEFAULT_VESPAAN_SERVER } from "../../utils/MainConstants";
import { FilePicker } from 'react-file-picker'
//import { FileInput, SVGIcon } from 'react-md';
//import fileDownload from 'icons/file_download.svg';
//import FormControlLabel from '@material-ui/core/FormControlLabel';
//import Checkbox from '@material-ui/core/Checkbox';


//import { deleteAStoragelot, loadStoragelotsData, saveAStoragelot, updateAStoragelot } from "../../redux/modules/storagelot";

/*import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from '@material-ui/pickers';
*/

//import { DateTimePicker } from "@material-ui/pickers";
const PurpleSwitch = withStyles({
	switchBase: {
		color: deepPurple[300],
		'&$checked': {
			color: deepPurple[700],
		},
		'&$checked + $track': {
			backgroundColor: deepPurple[200],
		},
	},
	checked: {},
	track: {},
})(Switch);

const styles = theme => ({
	main: {
		width: 'auto',
		display: 'block', // Fix IE 11 issue.
		marginLeft: theme.spacing.unit * 3,
		marginRight: theme.spacing.unit * 3,
		[theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
			width: 400,
			marginLeft: 'auto',
			marginRight: 'auto',
		},
	},
	paper: {
		marginTop: theme.spacing.unit * 8,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
	},
	avatar: {
		margin: theme.spacing.unit,
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing.unit,
	},
	submit: {
		marginTop: theme.spacing.unit * 3,
	},
	formControl: {
		//margin: theme.spacing.unit,
		minWidth: 200,
	},
	selectEmpty: {
		marginTop: theme.spacing.unit * 2,
	},
	button: {
		marginTop: theme.spacing.unit * 3,
		marginLeft: theme.spacing.unit,
		//backgroundColor: "#e2580d",
		backgroundColor: "#09aebd",
		fontSize: theme.typography.pxToRem(10),
		color: "black",
		textTransform: "unset !important",
	},
	
	bottomMargeStyle: {
		marginBottom: theme.spacing.unit * 1,
		marginTop: theme.spacing.unit * 1,
		
	},
	
	
	gridList: {
		width: 400,
		height: 400,
	},
	dividerColor: {
		//marginTop: theme.spacing.unit * 3,
		color: "#e2580d",
		backgroundColor: "#e2580d",
	},
	dividerColorPurpole: {
		//marginTop: theme.spacing.unit * 3,
		color: "#760eb3",
		backgroundColor: "#760eb3",
	},
	dividerColor1: {
		//marginTop: theme.spacing.unit * 3,
		color: "#ddedbb",
		backgroundColor: "#ddedbb",
	},
	switchColor: {
		//marginTop: theme.spacing.unit * 3,
		color: "#e2580d",
		//backgroundColor:"#ddedbb",
	},
	panelheading: {
		fontSize: theme.typography.pxToRem(15),
		flexBasis: '33.33%',
		flexShrink: 0,
	},
	panelsecondaryHeading: {
		fontSize: theme.typography.pxToRem(15),
		color: theme.palette.text.secondary,
	},
	typoTopMargin: {
		marginTop: '40',
	},
	lowMargin: {
		marginTop: '10',
	},
	grid1Control: {
		fontSize: 12,
		color: 'red',
	},
	formControl2: {
		//margin: theme.spacing.unit,
		width: '50%',
		
	},
	
	formControlLabel: {
		//margin: theme.spacing.unit,
		width: '100%',
		
	},
	/*
	switchBase: {
		color: deepPurple[300],
		'&$checked': {
			color: deepPurple[500],
		},
		'&$checked + $track': {
			backgroundColor: deepPurple[500],
		},
	},
	*/
	
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

const names = [
	"Accident",
	"Abandoned",
	"No Start",
	"Flat Tire",
	"Look out",
	"Tow Zone",
	"Stolen",
	"Snow Removal",
	"Break Down",
	"Unregistered",
	"Out Of Gas",
	"Fire Lane",
	"No Trespass",
	"Arrest",
	"Impounded",
	"Parking",
	"Other",
];

//const tempConst=[{"name":"", "phone":""}, {"name":"Fredo Khand", "phone":"617-999-3433"}];
const tempConst = [];
class TowForm extends React.Component {
	
	
	state = {
		
		chosenfile:"",
		//selectedLocation:{},
		selectedAuthorized: { "name": "me", "phone": "999" },
		selectedCompanyProperty: { "country": "U.S.A", "state": "Massachusetts" },
		inputFieldShrinkYear: true,
		selectedVehicle: { "country": "U.S.A", "state": "Massachusetts" },
		selectedPolice: { "country": "U.S.A", "state": "Massachusetts" },
		fullCompanyInHere: { "country": "U.S.A", "state": "Massachusetts" },
		//selectedCompanyInHere:{"country":"U.S.A", "state":"Massachusetts"},
		alterState: true,
		selectedDate: moment(),
		selectedRadioButton: 'Preconfigured',
		inputFieldShrinkState: true,
		selectedStoragelot: { "country": "U.S.A", "state": "Massachusetts" },
		selectedState: "Massachusetts",
		selectedCountry: "U.S.A",
		seletedReason: [],
		status:"",
		selectedNote: "",
		expandedpanel: "",
		fadePolice: false,
		showFaxDialog: false,
		showFaxSelectDialog: false,
		showEmailSelectDialog: false,
		selectedActionOne: "Select One",
		selectedInvoice: "",
		storageFaxCheck: false,
		policeFaxCheck: false,
		towFaxCheck: false,
		propertyFaxCheck: false,
		storageEmailCheck: false,
		propertyEmailCheck: false,
		policeEmailCheck: false,
		towEmailCheck: false,
		noticeButtonDisabled: true,
		faxButtonDisabled: true,
		emailButtonDisabled: true,
		clearFields: false,
		towId: undefined,
		saveTowButtonDisabled: false,
		updateTowButtonDisabled: false,
		showTowSavedDialog: false,
		
		
		cheifnameHelperText: "",
		cheifnameError: false,
		policedepartmentHelperText: "",
		policedepartmentError: false,
		policedaddress1HelperText: "",
		policeaddress1Error: false,
		policestateHelperText: "",
		policestateError: false,
		policecityHelperText: "",
		policecityError: false,
		policecountryHelperText: "",
		policecountryError: false,
		policezipcodeHelperText: "",
		policezipcodeError: false,
		
		
		storlotaddress1HelperText: "",
		storlotaddress1Error: false,
		storlotstateHelperText: "",
		storlotstateError: false,
		storlotcityHelperText: "",
		storlotcityError: false,
		storlotcountryHelperText: "",
		storlotcountryError: false,
		storlotzipcodeHelperText: "",
		storlotzipcodeError: false,
		storlotemailHelperText: "",
		storlotemailError: false,
		
		locationaddress1HelperText: "",
		locationaddress1Error: false,
		locationstateHelperText: "",
		locationstateError: false,
		locationcityHelperText: "",
		locationcityError: false,
		locationcountryHelperText: "",
		locationcountryError: false,
		locationzipcodeHelperText: "",
		locationzipcodeError: false,
		locationemailHelperText: "",
		locationemailError: false,
		
		causeHelperText: "",
		causeError: false,
		noteHelperText: "",
		noteError: false,
		
		vinHelperText: "",
		vinError: false,
		bodyHelperText: "",
		bodyError: false,
		typeHelperText: "",
		typeError: false,
		modelHelperText: "",
		modelError: false,
		makeHelperText: "",
		makeError: false,
		yearHelperText: "",
		yearError: false,
		colorHelperText: "",
		colorError: false,
		plateHelperText: "",
		plateError: false,
		vehicleStateHelperText: "",
		vehicleStateError: false,
		vehicleCountryHelperText: "",
		vehicleCountryError: false,
		loadError: false,
		files:[],
		privatepropertynumber:"",
		locationtype:"private",
		usPublicState:'',
		publicCountry:'',
		selectedPublicpropertyStateHere:{},
		//showEmailSelectDialog:false,
		
	};
	
	constructor(props) {
		super(props);
		//this.companySelectList=null;
		this.companySelectList = null;
		this.policeSelectList = null;
		this.storagelotsSelectList = null;
		this.companyPropertyList = null;
		this.peopleList = [];
		this.stompClient = null;
		this.editRecord = this.editRecord.bind(this);
		this.deleteRecord = this.deleteRecord.bind(this);
		this.clearFields = this.clearFields.bind(this);
		this.refresh = this.refresh.bind(this);
		this.handleTowJobSubmit = this.handleTowJobSubmit.bind(this);
		this.handleUpdateTowjob = this.handleUpdateTowjob.bind(this);
		this.handleUpdateTowjobByPassingStatus = this.handleUpdateTowjobByPassingStatus.bind(this);
		//this.handleFirstnameChange = this.handleFirstnameChange.bind(this);
		//this.handlePasswordChange = this.handlePasswordChange.bind(this);
		this.handleStateChange = this.handleStateChange.bind(this);
		this.handleStateSelectionChange = this.handleStateSelectionChange.bind(this);
		this.getListOfPoliceDepartmentsForSelection = this.getListOfPoliceDepartmentsForSelection.bind(this);
		
		this.handlePlatenumberChange = this.handlePlatenumberChange.bind(this);
		
		this.handleColorChange = this.handleColorChange.bind(this);
		this.handleYearChange = this.handleYearChange.bind(this);
		this.handleMakeChange = this.handleMakeChange.bind(this);
		this.handleModelChange = this.handleModelChange.bind(this);
		this.handleBodyChange = this.handleBodyChange.bind(this);
		this.handleTypeChange = this.handleTypeChange.bind(this);
		// this.getListOfVehicles = this.getListOfVehicles.bind(this);
		//this.handleVINChange = this.handleVINChange.bind(this);
		this.handleDateChange = this.handleDateChange.bind(this);
		this.handleRadioChange = this.handleRadioChange.bind(this);
		this.handleCountrySelectionChange = this.handleCountrySelectionChange.bind(this);
		this.handleCompanyPropertyChange = this.handleCompanyPropertyChange.bind(this);
		this.handlePoliceChange = this.handlePoliceChange.bind(this);
		this.handleStoragelotChange = this.handleStoragelotChange.bind(this);
		//this.handleCompanyChange = this.handleCompanyChange.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.handlePoliceStateChange = this.handlePoliceStateChange.bind(this);
		this.handlePoliceAddress1Change = this.handlePoliceAddress1Change.bind(this);
		this.handlePoliceZipcodeChange = this.handlePoliceZipcodeChange.bind(this);
		this.handlePoliceCityChange = this.handlePoliceCityChange.bind(this);
		this.handlePoliceCountryChange = this.handlePoliceCountryChange.bind(this);
		this.handlePoliceAddress2Change = this.handlePoliceAddress2Change.bind(this);
		this.handlePoliceChiefnameChange = this.handlePoliceChiefnameChange.bind(this);
		this.handlePoliceDepartmentChange = this.handlePoliceDepartmentChange.bind(this);
		this.handlePoliceStateSelectionChange = this.handlePoliceStateSelectionChange.bind(this);
		this.handlePoliceCountrySelectionChange = this.handlePoliceCountrySelectionChange.bind(this);
		//handlePoliceStateChange
		this.handleStoragelotStateChange = this.handleStoragelotStateChange.bind(this);
		this.handleStoragelotAddress1Change = this.handleStoragelotAddress1Change.bind(this);
		this.handleStoragelotZipcodeChange = this.handleStoragelotZipcodeChange.bind(this);
		this.handleStoragelotCityChange = this.handleStoragelotCityChange.bind(this);
		this.handleStoragelotCountryChange = this.handleStoragelotCountryChange.bind(this);
		this.handleStoragelotAddress2Change = this.handleStoragelotAddress2Change.bind(this);
		this.handleStoragelotStateSelectionChange = this.handleStoragelotStateSelectionChange.bind(this);
		this.handleStoragelotCountrySelectionChange = this.handleStoragelotCountrySelectionChange.bind(this);
		//CompanyProperty
		this.handleCompanyPropertyStateChange = this.handleCompanyPropertyStateChange.bind(this);
		this.handleCompanyPropertyAddress1Change = this.handleCompanyPropertyAddress1Change.bind(this);
		this.handleCompanyPropertyZipcodeChange = this.handleCompanyPropertyZipcodeChange.bind(this);
		this.handleCompanyPropertyCityChange = this.handleCompanyPropertyCityChange.bind(this);
		this.handleCompanyPropertyCountryChange = this.handleCompanyPropertyCountryChange.bind(this);
		this.handleCompanyPropertyAddress2Change = this.handleCompanyPropertyAddress2Change.bind(this);
		this.handleCompanyPropertyStateSelectionChange = this.handleCompanyPropertyStateSelectionChange.bind(this);
		this.handleCompanyPropertyCountrySelectionChange = this.handleCompanyPropertyCountrySelectionChange.bind(this);
		
		this.handlePublicCompanyPropertyStateSelectionChange = this.handlePublicCompanyPropertyStateSelectionChange.bind(this);
		this.handlePublicCompanyPropertyCountrySelectionChange = this.handlePublicCompanyPropertyCountrySelectionChange.bind(this);
		//
		this.handleVehicleCountrySelectionChange = this.handleVehicleCountrySelectionChange.bind(this);
		this.handleVehicleStateSelectionChange = this.handleVehicleStateSelectionChange.bind(this);
		this.handleVINChange = this.handleVINChange.bind(this);
		this.handleReasonChange = this.handleReasonChange.bind(this);
		this.handleReasonChangeMultiple = this.handleReasonChangeMultiple.bind(this);
		this.handleNoteChange = this.handleNoteChange.bind(this);
		this.setTheVehicleInformationForTowJob = this.setTheVehicleInformationForTowJob.bind(this);
		this.setTheStoragelotInformationForTowJob = this.setTheStoragelotInformationForTowJob.bind(this);
		this.setThePoliceInformationForTowJob = this.setThePoliceInformationForTowJob.bind(this);
		this.setTheLocationInformationForTowJob = this.setTheLocationInformationForTowJob.bind(this);
		this.setTheReasonInformationForTowJob = this.setTheReasonInformationForTowJob.bind(this);
		//this.handleFaxSubmit= this.handleFaxSubmit.bind(this);
		this.getListOfAuthorizedPeopleForSelection = this.getListOfAuthorizedPeopleForSelection.bind(this);
		this.handleAuthorizedPersonChange = this.handleAuthorizedPersonChange.bind(this);
		this.handlePanelExpantion = this.handlePanelExpantion.bind(this);
		this.handlePoliceFadeChange = this.handlePoliceFadeChange.bind(this);
		
		this.extractTheNoteInformationFromTowJob = this.extractTheNoteInformationFromTowJob.bind(this);
		this.extractTheLocationInformationFromTowJob = this.extractTheLocationInformationFromTowJob.bind(this);
		this.extractThePoliceInformationFromTowJob = this.extractThePoliceInformationFromTowJob.bind(this);
		this.extractTheStoragelotInformationFromTowJob = this.extractTheStoragelotInformationFromTowJob.bind(this);
		this.extractTheVehicleInformationFromTowJob = this.extractTheVehicleInformationFromTowJob.bind(this);
		this.handleEditModeChange = this.handleEditModeChange.bind(this);
		this.handleClickShowNotice = this.handleClickShowNotice.bind(this);
		this.handleClickShowNoticeClose = this.handleClickShowNoticeClose.bind(this);
		this.handleClickShowFaxSelect = this.handleClickShowFaxSelect.bind(this);
		this.handleClickShowFaxSelectClose = this.handleClickShowFaxSelectClose.bind(this);
		this.handleClickShowEmailSelect = this.handleClickShowEmailSelect.bind(this);
		this.handleClickShowEmailSelectClose = this.handleClickShowEmailSelectClose.bind(this);
		this.handleClickPrintFax = this.handleClickPrintFax.bind(this);
		this.printPdf = this.printPdf.bind(this);
		this.downloadPoliceNoticeFile = this.downloadPoliceNoticeFile.bind(this);
		this.handleWebSocketActionChange = this.handleWebSocketActionChange.bind(this);
		this.handleInvoiceChange = this.handleInvoiceChange.bind(this);
		this.setTheInvoiceInformationForTowJob = this.setTheInvoiceInformationForTowJob.bind(this);
		this.extractTheInvoiceInformationFromTowJob = this.extractTheInvoiceInformationFromTowJob.bind(this);
		this.renderFaxCheckBoxes = this.renderFaxCheckBoxes.bind(this);
		this.handleFaxCheckBoxChange = this.handleFaxCheckBoxChange.bind(this);
		
		this.renderEmailCheckBoxes = this.renderEmailCheckBoxes.bind(this);
		this.handleEmailCheckBoxChange = this.handleEmailCheckBoxChange.bind(this);
		//this.handleWebSocketConnection = this.handleWebSocketConnection.bind(this);
		this.handleCompanyPropertyEmailChange = this.handleCompanyPropertyEmailChange.bind(this);
		this.handleStoragelotEmailChange = this.handleStoragelotEmailChange.bind(this);
		this.extractTheReasonInformationForTowJob = this.extractTheReasonInformationForTowJob.bind(this);
		this.getSelectedCompnayFullInfo = this.getSelectedCompnayFullInfo.bind(this);
		this.buildFaxToPolice = this.buildFaxToPolice.bind(this);
		this.buildFaxToStorageLot = this.buildFaxToStorageLot.bind(this);
		this.buildFaxToProperty = this.buildFaxToProperty.bind(this);
		this.buildFaxToTowCompany = this.buildFaxToTowCompany.bind(this);
		this.buildAFaxRequest = this.buildAFaxRequest.bind(this);
		this.sendFax = this.sendFax.bind(this);
		
		this.buildEmailToPolice = this.buildEmailToPolice.bind(this);
		this.buildEmailToStorageLot = this.buildEmailToStorageLot.bind(this);
		this.buildEmailToProperty = this.buildEmailToProperty.bind(this);
		this.buildEmailToTowCompany = this.buildEmailToTowCompany.bind(this);
		this.buildAEmailRequest = this.buildAEmailRequest.bind(this);
		this.sendEmail = this.sendEmail.bind(this);
		this.resetAllErrorsAndErrorTexts = this.resetAllErrorsAndErrorTexts.bind(this);
		this.handleDecodeVin = this.handleDecodeVin.bind(this);
		this.handleClickShowSavedTowClose = this.handleClickShowSavedTowClose.bind(this);
		this.handleClickShowSavedTow = this.handleClickShowSavedTow.bind(this);
		this.handleUploadSelectedFile = this.handleUploadSelectedFile.bind(this);
		this.handleDropzoneChange = this.handleDropzoneChange.bind(this);
		this.hadleLoadedFile = this.hadleLoadedFile.bind(this);
		this.getPoliceInfoFromPoliceId= this.getPoliceInfoFromPoliceId.bind(this);
		this.getStoragelotInfoFromStorageId= this.getStoragelotInfoFromStorageId.bind(this);
		this.getPropertyInfoFromPropertyId= this.getPropertyInfoFromPropertyId.bind(this);
		this.getAuthorizedPeopleInfoFromProperty= this.getAuthorizedPeopleInfoFromProperty.bind(this);
		this.onRadioChangeValue= this.onRadioChangeValue.bind(this);
		this.getTheLocationInformationFromTowJob= this.getTheLocationInformationFromTowJob.bind(this);
		this.handlePublicAddressChange= this.handlePublicAddressChange.bind(this);
		this.handlePublicCityChange= this.handlePublicCityChange.bind(this);
		this.handlePublicZipcodeChange= this.handlePublicZipcodeChange.bind(this);
		this.handleDisptach= this.handleDisptach.bind(this);
		this.handleEnroute= this.handleEnroute.bind(this);
		this.handleOnscene= this.handleOnscene.bind(this);
		this.handleTowing= this.handleTowing.bind(this);
		this.handleCompleted= this.handleCompleted.bind(this);
		
		
		
		
		
		
		
		
		
		
		
		
		
		//may be I use it later --- this.handleCreatePoliceNotice= this.handleCreatePoliceNotice.bind(this);
		
		
		//this.websocketforconnect = this.websocketforconnect.bind(this);
		//this.websocketforconnect();
		
		
		/* this.socket = io.connect(`https://localhost:8080/chat`);
 
		 this.socket.on('receive prices', (payload) => {
			  console.log("Farshid the web socket payload is" + payload);
		 });
		 */
		
		
	}
	
	/*
		private String id;
		private String userId;
		private String model;
		private String make;
		private String year;
		private String color;
		private String plateNumber;
		private String state;
	*/
	
	/*connect() {
		var stompClient = null;
		 var socket = new SockJS('http://localhost:8080/app');
		 stompClient = Stomp.over(socket);
		 stompClient.connect({}, function (frame) {
			 //setConnected(true);
			 console.log('Connected: ' + frame);
			 if(stompClient != null) {
 
				 console.log("Hey Farshid, I DIDIDIDID subscrbe to the websoket ");
				 stompClient.subscribe('/topic/messages', function (messageOutput) {
					 //showMessageOutput(JSON.parse(messageOutput.body));
					 console.log("Farshid greaing message is " + JSON.parse(messageOutput.body));
				 });
				 this.stompClient = stompClient;
			 }else{
				 console.log("Hey Farshid, I didn't subscrbe to the websoket ");
			 }
 
		 });
	 }*/
	
	handlePublicAddressChange(value){
		this.setState(Object.assign(this.state.selectedPublicpropertyStateHere, { address1:value.target.value}));
	}
	
	handlePublicCityChange(value){
		this.setState(Object.assign(this.state.selectedPublicpropertyStateHere, { city:value.target.value}));
	}
	
	handlePublicZipcodeChange(value){
		this.setState(Object.assign(this.state.selectedPublicpropertyStateHere, { zipcode:value.target.value}));
	}
	
	handleDropzoneChange(files){
		this.setState({
			files: files
		});
	}
	
	/*  This was web socket test  */
	/*
	handleWebSocketConnection(frame) {

		//setConnected(true);
		let somepathid = "99999";
		console.log ("The company Id is " +this.props.selectedCompany );
		console.log('Connected: ' + frame);
		if (this.stompClient != null) {

			console.log("Hey Farshid, I DIDIDIDID subscrbe to the websoket ");
			this.stompClient.subscribe('/user/queue/specific-user -user shayan', function (messageOutput) {
				//showMessageOutput(JSON.parse(messageOutput.body));
				console.log("shayan greating string message is " + messageOutput.body);
				var tempMessageObject = JSON.parse(messageOutput.body);
				console.log("shayan tempMessageObject from is " + tempMessageObject.from);
				console.log("shayan tempMessageObject text is " + tempMessageObject.text);

			});
			//This worked fine with subsrcibeng to only one user , specific user call so only this user get any user specific response back. .
			this.stompClient.subscribe('/user/shayan/msg', function (messageOutput) {
				//showMessageOutput(JSON.parse(messageOutput.body));
				console.log("shayan2 greating string message is " + messageOutput.body);
				var tempMessageObject = JSON.parse(messageOutput.body);
				console.log("shayan2 tempMessageObject from is " + tempMessageObject.from);
				console.log("shayan2 tempMessageObject text is " + tempMessageObject.text);

			});
			//this.stompClient.subscribe('/topic/messages', function (messageOutput) {
			this.stompClient.subscribe('/topic/messages/99999', function (messageOutput) {
				//showMessageOutput(JSON.parse(messageOutput.body));
				console.log("Farshid greating string message is " + messageOutput.body);
				var tempMessageObject = JSON.parse(messageOutput.body);
				console.log("Farshid tempMessageObject from is " + tempMessageObject.from);
				console.log("Farshid tempMessageObject text is " + tempMessageObject.text);

			});
			


			//this.stompClient = stompClient;
		} else {
			console.log("Hey Farshid, I didn't subscribe to the websoket ");
		}
		//stompClient.subscribe('/topic/greetings', function (greeting) {
			//showGreeting(JSON.parse(greeting.body).content);

			//console.log("Farshid greaing message is "  + JSON.parse(greeting.body).content);
		//});


	}  */
	
	
	/*
	websocketforconnect() {
		//var stompClient = null;
		var socket = new SockJS('http://localhost:2500/app');
		this.stompClient = Stomp.over(socket);
		this.stompClient.connect({}, this.handleWebSocketConnection);
	 this.stompClient.send("/app/chat", {},
		  JSON.stringify({'from':"farshid", 'text':"Hello Buddy"}));
		  
	}
	*/
	
	
	handleStoragelotStateSelectionChange(event) {
		//this.setState({selectedState: event.target.value});
		this.setState(Object.assign(this.state.selectedStoragelot, { state: event.target.value }));
		this.setState({ numberShrink: true });
	}
	
	
	
	
	handleClickPrintFax() {
		
		// window.frames["farshids"].src = "http://localhost:8080/files";
		
		// window.frames["farshids"].print();
		//window.print('http://localhost:8080/files', "PRINT",  "height=400,width=600" );
		
		//this.printPdf("http://localhost:8080/files");
		this.printPartOfPage("farshids", "");
	};
	
	
	printPdf(url) {
		var iframe = this._printIframe;
		if (!this._printIframe) {
			iframe = this._printIframe = document.createElement('iframe');
			document.body.appendChild(iframe);
			
			iframe.style.display = 'none';
			iframe.onload = function () {
				setTimeout(function () {
					iframe.focus();
					iframe.contentWindow.print();
				}, 1);
			};
		}
		
		iframe.src = url;
	}
	
	
	
	printPartOfPage() {
		
		window.focus();
		window.print();
		
		// var iframe = document.getElementById('farshids');
		//iframe.getRootNode().print();
		//iframe.firstElementChild.parentNode.print();
		//iframe.contentWindow.print();
	}
	
	
	printPartOfPageOld(elementId, uniqueIframeId) {
		const content = document.getElementById(elementId)
		let pri
		let iframe;
		if (document.getElementById(uniqueIframeId)) {
			pri = document.getElementById(uniqueIframeId).contentWindow
		} else {
			iframe = document.createElement('iframe')
			iframe.setAttribute('title', uniqueIframeId)
			iframe.setAttribute('id', uniqueIframeId)
			iframe.setAttribute('style', 'height: 0px; width: 0px; position: absolute;')
			document.body.appendChild(iframe)
			pri = iframe.contentWindow
		}
		pri.document.open()
		pri.document.write(content.children.firstChild)
		pri.document.close()
		pri.focus()
		pri.print()
	}
	
	
	handleClickShowSavedTow() {
		this.setState({ showTowSavedDialog: true });
	};
	
	
	handleClickShowSavedTowClose() {
		let { clearTowErrorMsg } = this.props;
		this.setState({ showTowSavedDialog: false });
		clearTowErrorMsg();
	};
	
	handleClickShowEmailSelect() {
		//let {loadTowEmailsDataWithFilter} = this.props;
		//loadPdfFile(DEFAULT_VESPAAN_SERVER.url);
		//loadTowEmailsDataWithFilter(argURL, argCompanyId, argFilter)
		this.setState({ showEmailSelectDialog: true });
	};
	
	handleClickShowEmailSelectClose() {
		this.setState({ showEmailSelectDialog: false });
	};
	
	handleClickShowFaxSelect() {
		//let {loadPdfFile} = this.props;
		//loadPdfFile(DEFAULT_VESPAAN_SERVER.url);
		
		
		this.setState({ showFaxSelectDialog: true });
		
	};
	
	handleClickShowFaxSelectClose() {
		this.setState({ showFaxSelectDialog: false });
	};
	
	
	
	handleClickShowNotice() {
		//let {loadPdfFile} = this.props;
		//loadPdfFile(DEFAULT_VESPAAN_SERVER.url);
		
		this.setState({ loadError: false });
		this.setState({ showFaxDialog: true });
		
	};
	
	handleClickShowNoticeClose() {
		this.setState({ showFaxDialog: false });
	};
	
	
	handlePoliceFadeChange(value) {
		let tempValue = true;
		
		if (this.state.fadePolice) {
			this.setState({ fadePolice: false });
		} else {
			this.setState({ fadePolice: true });
		}
	}
	
	
	
	handlePanelExpantion(value) {
		if (value == this.state.expandedpanel) {
			this.setState({ expandedpanel: "" });
		} else {
			this.setState({ expandedpanel: value });
		}
	}
	
	
	
	handleStoragelotCountrySelectionChange(event) {
		this.setState(Object.assign(this.state.selectedStoragelot, { country: event.target.value }));
		
	}
	
	handleNoteChange(event) {
		if (event.target.value.length > 0) {
			this.setState({ noteHelperText: '', noteError: false });
			
		} else {
			this.setState({ noteHelperText: 'Required', noteError: true });
		}
		this.setState({ selectedNote: event.target.value });
		this.setState({ numberShrink: true });
	}
	
	handleStateSelectionChange(event) {
		this.setState({ selectedState: event.target.value });
		this.setState({ numberShrink: true });
	}
	
	handleCountrySelectionChange(event) {
		this.setState({ selectedCountry: event.target.value });
		
	}
	
	onDocumentLoadSuccess = ({ numPages }) => {
		this.setState({ numPages });
	}
	
	/*private String id;
	private String attachedFilepath;
	private String towId;
	private String senderFaxNumber;
	private String recipientFaxNumber;
	private String recipientName;
	private String recipientAddress;
	private String vehicleVin;
	private String vehiclePlateNumber;
	private String vehicleState;
	private String status;  //SENT, PENDING, QUEUED, FAILED
	private String confirmationId;
	private String towCompanyId;
	private String userId;
	private Date submittedDate;  // Puts it in QUEUED
	private Date completedDate; // Puts it in SENT
	private Date processedDate;  //Put it in PENDING status
	private Date createdDate;
	private Date modifiedDate;
	private Date endDate;
	*/
	
	//Email stuff
	buildAEmailRequest(argSenderEmail, argRecipientEmail, argRecipientName,
	                   argRecipientAddress) {
		var emailRequest = {};
		emailRequest.id = "";
		emailRequest.attachedFilepath = "";
		emailRequest.towId = this.state.towId;
		emailRequest.senderEmailAddress = argSenderEmail;
		emailRequest.recipientEmailAddress = argRecipientEmail;
		emailRequest.recipientName = argRecipientName;
		emailRequest.recipientAddress = argRecipientAddress;
		emailRequest.vehicleVin = this.state.selectedVehicle.vin;;
		emailRequest.vehiclePlateNumber = this.state.selectedVehicle.platenumber;
		emailRequest.vehicleState = this.state.selectedVehicle.state;
		emailRequest.color = this.state.selectedVehicle.color;
		emailRequest.make = this.props.decodedVinVehicleObject.make;
		emailRequest.model = this.props.decodedVinVehicleObject.model;
		emailRequest.status = "";
		emailRequest.confirmationId = "";
		emailRequest.towCompanyId = this.props.selectedCompanyInHere;;
		emailRequest.userId = "";
		emailRequest.submittedDate = "";
		emailRequest.completedDate = "";
		emailRequest.processedDate = "";
		emailRequest.createdDate = "";
		emailRequest.modifiedDate = "";
		emailRequest.endDate = "";
		return emailRequest;
		
	}
	
	buildEmailToTowCompany() {
		var recipientName = this.state.fullCompanyInHere.name;
		var recipientAddress = this.state.fullCompanyInHere.address1 + " " + this.state.fullCompanyInHere.address2 +
			this.state.fullCompanyInHere.city + ", " + this.state.fullCompanyInHere.state +
			" " + this.state.fullCompanyInHere.zipcode + " - " + this.state.fullCompanyInHere.country;
		var returnObj = this.buildAEmailRequest("", this.state.fullCompanyInHere.email,
			recipientName, recipientAddress);
		return returnObj;
		
	}
	
	buildEmailToProperty() {
		var recipientName = this.state.selectedCompanyProperty.name;
		var recipientAddress = this.state.selectedCompanyProperty.address1 + " " + this.state.selectedCompanyProperty.address2 +
			this.state.selectedCompanyProperty.city + ", " + this.state.selectedCompanyProperty.state +
			" " + this.state.selectedCompanyProperty.zipcode + " - " + this.state.selectedCompanyProperty.country;
		var returnObj = this.buildAEmailRequest("", this.state.selectedCompanyProperty.email,
			recipientName, recipientAddress);
		return returnObj;
		
	}
	
	buildEmailToStorageLot() {
		var recipientName = this.state.selectedStoragelot.name;
		var recipientAddress = this.state.selectedStoragelot.address1 + " " + this.state.selectedStoragelot.address2 +
			this.state.selectedStoragelot.city + ", " + this.state.selectedStoragelot.state +
			" " + this.state.selectedStoragelot.zipcode + " - " + this.state.selectedStoragelot.country;
		var returnObj = this.buildAEmailRequest("", this.state.selectedStoragelot.email,
			recipientName, recipientAddress);
		return returnObj;
		
	}
	
	
	buildEmailToPolice() {
		var recipientName = this.state.selectedPolice.departmentname + " " + this.state.selectedPolice.chiefname;
		var recipientAddress = this.state.selectedPolice.address1 + " " + this.state.selectedPolice.address2 +
			this.state.selectedPolice.city + ", " + this.state.selectedPolice.state +
			" " + this.state.selectedPolice.zipcode + " - " + this.state.selectedPolice.country;
		var returnObj = this.buildAEmailRequest("", this.state.selectedPolice.email,
			recipientName, recipientAddress);
		return returnObj;
		
	}
	
	//Fax stuff
	buildFaxToTowCompany() {
		var recipientName = this.state.fullCompanyInHere.name;
		var recipientAddress = this.state.fullCompanyInHere.address1 + " " + this.state.fullCompanyInHere.address2 +
			this.state.fullCompanyInHere.city + ", " + this.state.fullCompanyInHere.state +
			" " + this.state.fullCompanyInHere.zipcode + " - " + this.state.fullCompanyInHere.country;
		var returnObj = this.buildAFaxRequest(this.state.fullCompanyInHere.fax, this.state.fullCompanyInHere.fax,
			recipientName, recipientAddress);
		return returnObj;
		
	}
	
	buildFaxToProperty() {
		var recipientName = this.state.selectedCompanyProperty.name;
		var recipientAddress = this.state.selectedCompanyProperty.address1 + " " + this.state.selectedCompanyProperty.address2 +
			this.state.selectedCompanyProperty.city + ", " + this.state.selectedCompanyProperty.state +
			" " + this.state.selectedCompanyProperty.zipcode + " - " + this.state.selectedCompanyProperty.country;
		var returnObj = this.buildAFaxRequest(this.state.fullCompanyInHere.fax, this.state.selectedCompanyProperty.fax,
			recipientName, recipientAddress);
		return returnObj;
		
	}
	
	buildFaxToStorageLot() {
		var recipientName = this.state.selectedStoragelot.name;
		var recipientAddress = this.state.selectedStoragelot.address1 + " " + this.state.selectedStoragelot.address2 +
			this.state.selectedStoragelot.city + ", " + this.state.selectedStoragelot.state +
			" " + this.state.selectedStoragelot.zipcode + " - " + this.state.selectedStoragelot.country;
		var returnObj = this.buildAFaxRequest(this.state.fullCompanyInHere.fax, this.state.selectedStoragelot.fax,
			recipientName, recipientAddress);
		return returnObj;
		
	}
	
	
	buildFaxToPolice() {
		var recipientName = this.state.selectedPolice.departmentname + " " + this.state.selectedPolice.chiefname;
		var recipientAddress = this.state.selectedPolice.address1 + " " + this.state.selectedPolice.address2 +
			this.state.selectedPolice.city + ", " + this.state.selectedPolice.state +
			" " + this.state.selectedPolice.zipcode + " - " + this.state.selectedPolice.country;
		var returnObj = this.buildAFaxRequest(this.state.fullCompanyInHere.fax, this.state.selectedPolice.fax,
			recipientName, recipientAddress);
		return returnObj;
		
	}
	
	
	buildAFaxRequest(argSenderFax, argRecipientFax, argRecipientName,
	                 argRecipientAddress) {
		var faxRequest = {};
		faxRequest.id = "";
		faxRequest.attachedFilepath = "";
		faxRequest.towId = this.state.towId;
		faxRequest.senderFaxNumber = argSenderFax;
		faxRequest.recipientFaxNumber = argRecipientFax;
		faxRequest.recipientName = argRecipientName;
		faxRequest.recipientAddress = argRecipientAddress;
		faxRequest.vehicleVin = this.state.selectedVehicle.vin;
		faxRequest.vehiclePlateNumber = this.state.selectedVehicle.platenumber;
		faxRequest.vehicleState = this.state.selectedVehicle.state;
		faxRequest.color = this.state.selectedVehicle.color;
		faxRequest.make = this.props.decodedVinVehicleObject.make;
		faxRequest.model = this.props.decodedVinVehicleObject.model;
		faxRequest.status = "";
		faxRequest.confirmationId = "";
		faxRequest.towCompanyId = this.props.selectedCompanyInHere;
		faxRequest.userId = "";
		faxRequest.submittedDate = "";
		faxRequest.completedDate = "";
		faxRequest.processedDate = "";
		faxRequest.createdDate = "";
		faxRequest.modifiedDate = "";
		faxRequest.endDate = "";
		return faxRequest;
		
	}
	
	sendFax() {
		let { saveAFax } = this.props;
		var faxRequest = { 'faxes': [] };
		
		if (this.state.policeFaxCheck == true) {
			faxRequest.faxes.push(this.buildFaxToPolice());
		}
		
		if (this.state.towFaxCheck == true) {
			faxRequest.faxes.push(this.buildFaxToTowCompany());
		}
		
		if (this.state.storageFaxCheck == true) {
			faxRequest.faxes.push(this.buildFaxToStorageLot());
		}
		
		if (this.state.propertyFaxCheck == true) {
			faxRequest.faxes.push(this.buildFaxToProperty());
		}
		saveAFax(DEFAULT_VESPAAN_SERVER.url, faxRequest, this.props.selectedCompanyInHere);
		
	}
	
	
	sendEmail() {
		let { saveAEmail } = this.props;
		var emailRequest = { 'emails': [] };
		
		if (this.state.policeEmailCheck == true) {
			emailRequest.emails.push(this.buildEmailToPolice());
		}
		
		if (this.state.towEmailCheck == true) {
			emailRequest.emails.push(this.buildEmailToTowCompany());
		}
		
		if (this.state.storageEmailCheck == true) {
			emailRequest.emails.push(this.buildEmailToStorageLot());
		}
		
		if (this.state.propertyEmailCheck == true) {
			emailRequest.emails.push(this.buildEmailToProperty());
		}
		saveAEmail(DEFAULT_VESPAAN_SERVER.url, emailRequest,this.props.selectedCompanyInHere);
		
		
	}
	
	
	
	
	/*
	handleFaxSubmit () {
		let { saveAFax} = this.props;
		var tempTowjob = {};
		tempTowjob = this.setTheVehicleInformationForTowJob(tempTowjob) ;
		tempTowjob = this.setTheStoragelotInformationForTowJob(tempTowjob) ;
		tempTowjob = this.setThePoliceInformationForTowJob(tempTowjob) ;
		tempTowjob = this.setTheLocationInformationForTowJob(tempTowjob) ;
		tempTowjob = this.setTheReasonInformationForTowJob(tempTowjob) ;
		tempTowjob = this.setTheInvoiceInformationForTowJob(tempTowjob) ;
		
		//setTheReasonInformationForTowJob
		saveAFax(DEFAULT_VESPAAN_SERVER.url,  tempTowjob, this.props.selectedCompany);
		
	};*/
	
	handleTowJobSubmit() {
		let { saveATowjob } = this.props;
		var tempTowjob = {};
		tempTowjob = this.setTheVehicleInformationForTowJob(tempTowjob);
		tempTowjob = this.setTheStoragelotInformationForTowJob(tempTowjob);
		tempTowjob = this.setThePoliceInformationForTowJob(tempTowjob);
		tempTowjob = this.setTheLocationInformationForTowJob(tempTowjob);
		tempTowjob = this.setTheReasonInformationForTowJob(tempTowjob);
		tempTowjob = this.setTheInvoiceInformationForTowJob(tempTowjob);
		//tempTowjob.towcompanyid = this.props.selectedCompany;
		
		tempTowjob.towcompanyid = this.props.selectedCompanyInHere;
		tempTowjob.towcompanyname = this.state.fullCompanyInHere.name;
		this.setState({ saveTowButtonDisabled: false});
		this.setState({ upadteTowButtonDisabled: false });
		
		
		//setTheReasonInformationForTowJob
		
		//saveATowjob(DEFAULT_VESPAAN_SERVER.url, tempTowjob, this.props.selectedCompany);
		//Farshid
		saveATowjob(DEFAULT_VESPAAN_SERVER.url, tempTowjob, this.props.selectedCompanyInHere);
		//this.props.onRefreshList();
		
	};
	
	/* This is if we have to have a sperate create notice. Righ now any time we save teh two we also create teh notice.

	handleCreatePoliceNotice () {
		let { saveAPolicenotice} = this.props;
		var tempTowjob = {};
		tempTowjob = this.setTheVehicleInformationForTowJob(tempTowjob) ;
		tempTowjob = this.setTheStoragelotInformationForTowJob(tempTowjob) ;
		tempTowjob = this.setThePoliceInformationForTowJob(tempTowjob) ;
		tempTowjob = this.setTheLocationInformationForTowJob(tempTowjob) ;
		tempTowjob = this.setTheReasonInformationForTowJob(tempTowjob) ;
		tempTowjob = this.setTheInvoiceInformationForTowJob(tempTowjob) ;
		tempTowjob.towcompanyid = this.state.selectedCompany.id;

		//setTheReasonInformationForTowJob
		saveAPolicenotice(DEFAULT_VESPAAN_SERVER.url,  tempTowjob, this.state.selectedCompany.id);
		//this.props.onRefreshList();

	};

	*/
	
	handleUpdateTowjob() {
		let { updateATowjob } = this.props;
		
		var tempTowjob = {};
		tempTowjob = this.setTheVehicleInformationForTowJob(tempTowjob);
		tempTowjob = this.setTheStoragelotInformationForTowJob(tempTowjob);
		tempTowjob = this.setThePoliceInformationForTowJob(tempTowjob);
		tempTowjob = this.setTheLocationInformationForTowJob(tempTowjob);
		tempTowjob = this.setTheReasonInformationForTowJob(tempTowjob);
		tempTowjob = this.setTheInvoiceInformationForTowJob(tempTowjob);
		tempTowjob.towcompanyid = this.props.selectedCompanyInHere;
		tempTowjob.towcompanyname = this.state.fullCompanyInHere.name;
		tempTowjob.id = this.state.towId;  //we need to set the tow id for the job going back for update
		this.setState({ saveTowButtonDisabled: false });
		this.setState({ updateTowButtonDisabled: false });
		
		//var tempTowjob = this.state.selectedVehicle ;
		//tempStream.locationId= this.state.selectedLocation.id;
		updateATowjob(DEFAULT_VESPAAN_SERVER.url, tempTowjob, this.props.selectedCompanyInHere);
		
		//this.props.onRefreshList();
		
	};
	
	
	handleUpdateTowjobByPassingStatus(argStatus) {
		let { updateATowjob } = this.props;
		
		var tempTowjob = {};
		tempTowjob = this.setTheVehicleInformationForTowJob(tempTowjob);
		tempTowjob = this.setTheStoragelotInformationForTowJob(tempTowjob);
		tempTowjob = this.setThePoliceInformationForTowJob(tempTowjob);
		tempTowjob = this.setTheLocationInformationForTowJob(tempTowjob);
		tempTowjob = this.setTheReasonInformationForTowJob(tempTowjob);
		tempTowjob = this.setTheInvoiceInformationForTowJob(tempTowjob);
		tempTowjob.privatepropertynumber =  this.state.privatepropertynumber;
		tempTowjob.towcompanyid = this.props.selectedCompanyInHere;
		tempTowjob.towcompanyname = this.state.fullCompanyInHere.name;
		tempTowjob.id = this.state.towId;  //we need to set the tow id for the job going back for update
		tempTowjob.status = argStatus;
		this.setState({ saveTowButtonDisabled: false });
		this.setState({ updateTowButtonDisabled: false });
		//var tempTowjob = this.state.selectedVehicle ;
		//tempStream.locationId= this.state.selectedLocation.id;
		updateATowjob(DEFAULT_VESPAAN_SERVER.url, tempTowjob, this.props.selectedCompanyInHere);
		//this.props.onRefreshList();
	};
	
	handleDisptach (event) {
		this.setState({status:'Dispatched'});
		this.handleUpdateTowjobByPassingStatus('Dispatched');
		
	}
	handleEnroute(event) {
		this.setState({status:'Enroute'});
		this.handleUpdateTowjobByPassingStatus('Enroute');
	}
	
	handleOnscene (event) {
		this.setState({status:'Onscene'});
		this.handleUpdateTowjobByPassingStatus('Onscene');
	}
	
	handleTowing (event) {
		this.setState({status:'Towing'});
		this.handleUpdateTowjobByPassingStatus('Towing');
	}
	
	handleCompleted (event) {
		this.setState({status:'Complete'});
		this.handleUpdateTowjobByPassingStatus('Complete');
	}
	
	extractTheReasonInformationForTowJob(returnTowjob) {
		if (returnTowjob != undefined) {
			var str = returnTowjob.reasoncause;
			var resArray = str.split(",");
			this.setState({ seletedReason: resArray });
		}
		//this.setState({selectedNote:returnTowjob.reasonnote});
	}
	
	extractTheNoteInformationFromTowJob(returnTowjob) {
		
		this.setState({ selectedNote: returnTowjob.reasonnote });
		
	}
	
	extractTheInvoiceInformationFromTowJob(returnTowjob) {
		
		this.setState({ selectedInvoice: returnTowjob.invoice });
		
	}
	
	extractTheLocationInformationFromTowJob(returnTowjob) {
		
		let tempCompanyPropertyInfo = {};
		
		tempCompanyPropertyInfo.id = returnTowjob.locationid;
		tempCompanyPropertyInfo.name = returnTowjob.locationname;
		tempCompanyPropertyInfo.phone = returnTowjob.locationphone;
		tempCompanyPropertyInfo.fax = returnTowjob.locationfax;
		tempCompanyPropertyInfo.address1 = returnTowjob.locationaddress1;
		tempCompanyPropertyInfo.address2 = returnTowjob.locationaddress2;
		tempCompanyPropertyInfo.city = returnTowjob.locationcity;
		tempCompanyPropertyInfo.state = returnTowjob.locationstate;
		tempCompanyPropertyInfo.country = returnTowjob.locationcountry;
		tempCompanyPropertyInfo.zipcode = returnTowjob.locationzipcode;
		tempCompanyPropertyInfo.email = returnTowjob.locationemail;
		tempCompanyPropertyInfo.type = returnTowjob.locationtype;
		
		this.setState({ selectedCompanyProperty: tempCompanyPropertyInfo });
		
		/*


	   returnTowjob.locationauthorizedpeople = this.state.selectedAuthorized.name;


	   */
	}
	
	
	resetAllErrorsAndErrorTexts() {
		
		this.setState({
			cheifnameHelperText: "",
			cheifnameError: false,
			policedepartmentHelperText: "",
			policedepartmentError: false,
			policedaddress1HelperText: "",
			policeaddress1Error: false,
			policestateHelperText: "",
			policestateError: false,
			policecityHelperText: "",
			policecityError: false,
			policecountryHelperText: "",
			policecountryError: false,
			policezipcodeHelperText: "",
			policezipcodeError: false,
			
			
			storlotaddress1HelperText: "",
			storlotaddress1Error: false,
			storlotstateHelperText: "",
			storlotstateError: false,
			storlotcityHelperText: "",
			storlotcityError: false,
			storlotcountryHelperText: "",
			storlotcountryError: false,
			storlotzipcodeHelperText: "",
			storlotzipcodeError: false,
			storlotemailHelperText: "",
			storlotemailError: false,
			
			locationaddress1HelperText: "",
			locationaddress1Error: false,
			locationstateHelperText: "",
			locationstateError: false,
			locationcityHelperText: "",
			locationcityError: false,
			locationcountryHelperText: "",
			locationcountryError: false,
			locationzipcodeHelperText: "",
			locationzipcodeError: false,
			locationemailHelperText: "",
			locationemailError: false,
			
			causeHelperText: "",
			causeError: false,
			noteHelperText: "",
			noteError: false,
			
			vinHelperText: "",
			vinError: false,
			bodyHelperText: "",
			bodyError: false,
			typeHelperText: "",
			typeError: false,
			modelHelperText: "",
			modelError: false,
			makeHelperText: "",
			makeError: false,
			yearHelperText: "",
			yearError: false,
			colorHelperText: "",
			colorError: false,
			plateHelperText: "",
			plateError: false,
			vehicleStateHelperText: "",
			vehicleStateError: false,
			vehicleCountryHelperText: "",
			vehicleCountryError: false,
			
		});
	}
	extractThePoliceInformationFromTowJob(returnTowjob) {
		
		let tempPoliceInfo = {};
		
		tempPoliceInfo.departmentname = returnTowjob.policedepartmentname;
		tempPoliceInfo.chiefname = returnTowjob.policechiefname;
		tempPoliceInfo.email = returnTowjob.policeemail;
		tempPoliceInfo.phone = returnTowjob.policephone;
		tempPoliceInfo.fax = returnTowjob.policefax;
		tempPoliceInfo.address1 = returnTowjob.policeaddress1;
		tempPoliceInfo.address2 = returnTowjob.policeaddress2;
		tempPoliceInfo.city = returnTowjob.policecity;
		tempPoliceInfo.state = returnTowjob.policestate;
		tempPoliceInfo.country = returnTowjob.policecountry;
		tempPoliceInfo.zipcode = returnTowjob.policezipcode;
		tempPoliceInfo.id = returnTowjob.policeid;
		
		this.setState({ selectedPolice: tempPoliceInfo });
		return tempPoliceInfo;
		
	}
	
	extractTheStoragelotInformationFromTowJob(returnTowjob) {
		let tempStoragelotInfo = {};
		tempStoragelotInfo.id = returnTowjob.storagelotid;
		tempStoragelotInfo.name = returnTowjob.storagelotname;
		tempStoragelotInfo.phone = returnTowjob.storagelotphone;
		tempStoragelotInfo.fax = returnTowjob.storagelotfax;
		tempStoragelotInfo.address1 = returnTowjob.storagelotaddress1;
		tempStoragelotInfo.address2 = returnTowjob.storagelotaddress2;
		tempStoragelotInfo.city = returnTowjob.storagelotcity;
		tempStoragelotInfo.state = returnTowjob.storagelotstate;
		tempStoragelotInfo.country = returnTowjob.storagelotcountry;
		tempStoragelotInfo.email = returnTowjob.storagelotemail;
		tempStoragelotInfo.zipcode = returnTowjob.storagelotzipcode;
		this.setState({ selectedStoragelot: tempStoragelotInfo });
		this.setState({privatepropertynumber: returnTowjob.privatepropertynumber})
	}
	
	extractTheVehicleInformationFromTowJob(returnTowjob) {
		
		let { decodeVin } = this.props;
		let tempVehicleInfo = {};
		tempVehicleInfo.id = returnTowjob.vehicleid;
		//tempVehicleInfo.model = returnTowjob.vehiclemodel;
		//tempVehicleInfo.make = returnTowjob.vehiclemake;
		//tempVehicleInfo.year = returnTowjob.vehicleyear;
		tempVehicleInfo.color = returnTowjob.vehiclecolor;
		tempVehicleInfo.platenumber = returnTowjob.vehicleplatenumber;
		tempVehicleInfo.state = returnTowjob.vehiclestate;
		tempVehicleInfo.vin = returnTowjob.vehiclevin;
		tempVehicleInfo.country = returnTowjob.vehiclecountry;
		
		//tempVehicleInfo.body = returnTowjob.vehiclebody;
		//tempVehicleInfo.type = returnTowjob.vehicletype;
		this.setState({ selectedVehicle: tempVehicleInfo });
		
		
		
		decodeVin(tempVehicleInfo.vin);
		/*
		if((this.props.decodedVinVehicleObject.model == null ) ||  (this.props.decodedVinVehicleObject.model == 'undefined' )){
			console.log("I am calling the decodeVin");
			decodeVin(tempVehicleInfo.vin);
		}else{
			console.log("I am NOT calling the decodeVin"  + this.props.decodedVinVehicleObject.model );
			
		}
		*/
	}
	
	
	
	setTheInvoiceInformationForTowJob(returnTowjob) {
		returnTowjob.invoice = this.state.selectedInvoice;
		
		return returnTowjob;
	}
	
	setTheReasonInformationForTowJob(returnTowjob) {
		returnTowjob.reasoncause = this.state.seletedReason.toString();
		returnTowjob.reasonnote = this.state.selectedNote;
		return returnTowjob;
	}
	
	setTheLocationInformationForTowJob(returnTowjob) {
		if(this.state.locationtype =='private') {
			returnTowjob.locationid = this.state.selectedCompanyProperty.id;
			returnTowjob.locationname = this.state.selectedCompanyProperty.name;
			returnTowjob.locationphone = this.state.selectedCompanyProperty.phone;
			returnTowjob.locationfax = this.state.selectedCompanyProperty.fax;
			returnTowjob.locationaddress1 = this.state.selectedCompanyProperty.address1;
			returnTowjob.locationaddress2 = this.state.selectedCompanyProperty.address2;
			returnTowjob.locationcity = this.state.selectedCompanyProperty.city;
			returnTowjob.locationstate = this.state.selectedCompanyProperty.state;
			returnTowjob.locationcountry = this.state.selectedCompanyProperty.country;
			returnTowjob.locationzipcode = this.state.selectedCompanyProperty.zipcode;
			returnTowjob.locationemail = this.state.selectedCompanyProperty.email;
			returnTowjob.locationtype = this.state.selectedCompanyProperty.type;
			returnTowjob.locationauthorizedpeople = this.state.selectedAuthorized.name;
		}else{
			returnTowjob.locationid = "";
			returnTowjob.locationname = "Public Property";
			returnTowjob.locationphone = "";
			returnTowjob.locationfax = "";
			returnTowjob.locationaddress1 = this.state.selectedPublicpropertyStateHere.address1;
			returnTowjob.locationaddress2 = "";
			returnTowjob.locationcity = this.state.selectedPublicpropertyStateHere.city;
			//returnTowjob.locationstate = this.state.usPublicState;
			//returnTowjob.locationcountry = this.state.publicCountry;
			
			returnTowjob.locationstate = this.state.selectedPublicpropertyStateHere.state;
			returnTowjob.locationcountry = this.state.selectedPublicpropertyStateHere.country;
			returnTowjob.locationzipcode = "";
			returnTowjob.locationemail = null;
			returnTowjob.locationtype =this.state.locationtype ;
			returnTowjob.locationauthorizedpeople = null;
		}
		return returnTowjob;
	}
	
	setThePoliceInformationForTowJob(returnTowjob) {
		returnTowjob.policedepartmentname = this.state.selectedPolice.departmentname;
		returnTowjob.policechiefname = this.state.selectedPolice.chiefname;
		returnTowjob.policeemail = this.state.selectedPolice.email;
		returnTowjob.policephone = this.state.selectedPolice.phone;
		returnTowjob.policefax = this.state.selectedPolice.fax;
		returnTowjob.policeaddress1 = this.state.selectedPolice.address1;
		returnTowjob.policeaddress2 = this.state.selectedPolice.address2;
		returnTowjob.policecity = this.state.selectedPolice.city;
		returnTowjob.policestate = this.state.selectedPolice.state;
		returnTowjob.policecountry = this.state.selectedPolice.country;
		returnTowjob.policezipcode = this.state.selectedPolice.zipcode;
		returnTowjob.policeid = this.state.selectedPolice.id;
		return returnTowjob;
	}
	
	setTheStoragelotInformationForTowJob(returnTowjob) {
		
		returnTowjob.storagelotid = this.state.selectedStoragelot.id;
		returnTowjob.storagelotname = this.state.selectedStoragelot.name;
		returnTowjob.storagelotphone = this.state.selectedStoragelot.phone;
		returnTowjob.storagelotfax = this.state.selectedStoragelot.fax;
		returnTowjob.storagelotaddress1 = this.state.selectedStoragelot.address1;
		returnTowjob.storagelotaddress2 = this.state.selectedStoragelot.address2;
		returnTowjob.storagelotcity = this.state.selectedStoragelot.city;
		returnTowjob.storagelotstate = this.state.selectedStoragelot.state;
		returnTowjob.storagelotcountry = this.state.selectedStoragelot.country;
		returnTowjob.storagelotemail = this.state.selectedStoragelot.email;
		returnTowjob.storagelotzipcode = this.state.selectedStoragelot.zipcode;
		return returnTowjob;
		
	}
	
	setTheVehicleInformationForTowJob(returnTowjob) {
		
		returnTowjob.vehicleid = this.state.selectedVehicle.id;
		returnTowjob.vehiclemodel = this.props.decodedVinVehicleObject.model;
		returnTowjob.vehiclemake = this.props.decodedVinVehicleObject.make;
		returnTowjob.vehicleyear = this.props.decodedVinVehicleObject.year;
		returnTowjob.vehiclecolor = this.state.selectedVehicle.color;
		var tempPlate = this.state.selectedVehicle.platenumber.toUpperCase();
		tempPlate = tempPlate.trim();
		tempPlate = tempPlate.replace(/\s+/g, '');
		returnTowjob.vehicleplatenumber = tempPlate
		returnTowjob.vehiclestate = this.state.selectedVehicle.state;
		//returnTowjob.vehiclevin = this.state.selectedVehicle.vin.toUpperCase();
		var tempVin = this.state.selectedVehicle.vin.toUpperCase();
		tempVin = tempVin.trim();
		tempVin = tempVin.replace(/\s+/g, '');
		returnTowjob.vehiclevin = tempVin;
		returnTowjob.vehiclecountry = this.state.selectedVehicle.country;
		returnTowjob.vehiclebody = this.props.decodedVinVehicleObject.body;
		returnTowjob.vehicletype = this.props.decodedVinVehicleObject.type;
		return returnTowjob;
		
		
	}
	
	handleFaxCheckBoxChange(event) {
		//setState({ ...state, [name]: event.target.checked });
		if (event == "police") {
			if (this.state.policeFaxCheck == true) {
				this.setState({ policeFaxCheck: false });
			} else {
				this.setState({ policeFaxCheck: true });
			}
		} else if (event == "tow") {
			if (this.state.towFaxCheck == true) {
				this.setState({ towFaxCheck: false });
			} else {
				this.setState({ towFaxCheck: true });
			}
		} else if (event == "storage") {
			if (this.state.storageFaxCheck == true) {
				this.setState({ storageFaxCheck: false });
			} else {
				this.setState({ storageFaxCheck: true });
			}
		} else if (event == "property") {
			if (this.state.propertyFaxCheck == true) {
				this.setState({ propertyFaxCheck: false });
			} else {
				this.setState({ propertyFaxCheck: true });
			}
		}
	};
	
	handleEmailCheckBoxChange(event) {
		if (event == "police") {
			if (this.state.policeEmailCheck == true) {
				this.setState({ policeEmailCheck: false });
			} else {
				this.setState({ policeEmailCheck: true });
			}
		} else if (event == "tow") {
			if (this.state.towEmailCheck == true) {
				this.setState({ towEmailCheck: false });
			} else {
				this.setState({ towEmailCheck: true });
			}
		} else if (event == "storage") {
			if (this.state.storageEmailCheck == true) {
				this.setState({ storageEmailCheck: false });
			} else {
				this.setState({ storageEmailCheck: true });
			}
		} else if (event == "property") {
			if (this.state.propertyEmailCheck == true) {
				this.setState({ propertyEmailCheck: false });
			} else {
				this.setState({ propertyEmailCheck: true });
			}
		}
	};
	
	renderFaxCheckBoxes() {
		const { classes } = this.props;
		
		var j = 0;
		
		var policefaxstatus = 'Unknown'
		var policefaxdate = 'Unknown'
		
		var propertyfaxstatus = 'Unknown'
		var propertyfaxdate = 'Unknown'
		
		var storagefaxstatus = 'Unknown'
		var storagefaxdate = 'Unknown'
		
		var companyfaxstatus = 'Unknown'
		var companyfaxdate = 'Unknown'
		
		if ((this.props.towFaxsArray != null) && (this.props.towFaxsArray != undefined)) {
			for (j = 0; j < this.props.towFaxsArray.length; j++) {
				
				var temFax = this.props.towFaxsArray[j];
				if (temFax != null) {
					
					if (temFax.recipientFaxNumber == this.state.selectedPolice.fax) {
						
						policefaxstatus = temFax.status;
						var policefaxdate = "---";
						if (temFax.completedDate != null) {
							//policefaxdate = new Date(temFax.processedDate)
							
							policefaxdate = new Date(temFax.completedDate);
							var hour = policefaxdate.getHours() % 12;
							var newformat = policefaxdate.getHours() >= 12 ? 'PM' : 'AM';
							var minuteStr = policefaxdate.getMinutes() <= 9 ? "0" + policefaxdate.getMinutes() : policefaxdate.getMinutes();
							policefaxdate = (policefaxdate.getMonth() +1) + "/" + policefaxdate.getDate() + "/" + policefaxdate.getFullYear() + " " + hour + ":" + minuteStr + " " + newformat;
						}
					} else if ((this.state.selectedCompanyProperty != null)&& (temFax.recipientFaxNumber == this.state.selectedCompanyProperty.fax)) {
						
						propertyfaxstatus = temFax.status;
						var propertyfaxdate = "---";
						if (temFax.completedDate != null) {
							//propertyfaxdate = new Date(temFax.processedDate);
							propertyfaxdate = new Date(temFax.completedDate);
							var hour = propertyfaxdate.getHours() % 12;
							var newformat = propertyfaxdate.getHours() >= 12 ? 'PM' : 'AM';
							var minuteStr = propertyfaxdate.getMinutes() <= 9 ? "0" + propertyfaxdate.getMinutes() : propertyfaxdate.getMinutes();
							propertyfaxdate = (propertyfaxdate.getMonth()+1) + "/" + propertyfaxdate.getDate() + "/" + propertyfaxdate.getFullYear() + " " + hour + ":" + minuteStr + " " + newformat;
						}
						
					} else if (temFax.recipientFaxNumber == this.state.selectedStoragelot.fax) {
						
						storagefaxstatus = temFax.status;
						var storagefaxdate = "---";
						if (temFax.completedDate != null) {
							//storagefaxdate = new Date(temFax.processedDate);
							storagefaxdate = new Date(temFax.completedDate);
							var hour = storagefaxdate.getHours() % 12;
							var newformat = storagefaxdate.getHours() >= 12 ? 'PM' : 'AM';
							var minuteStr = storagefaxdate.getMinutes() <= 9 ? "0" + storagefaxdate.getMinutes() : storagefaxdate.getMinutes();
							storagefaxdate = (storagefaxdate.getMonth()+1) + "/" + storagefaxdate.getDate() + "/" + storagefaxdate.getFullYear() + " " + hour + ":" + minuteStr + " " + newformat;
						}
						
						
					} else if (temFax.recipientFaxNumber == this.state.fullCompanyInHere.fax) {
						companyfaxstatus = temFax.status;
						var companyfaxdate = "---";
						if (temFax.completedDate != null) {
							//companyfaxdate = new Date(temFax.processedDate);
							companyfaxdate = new Date(temFax.completedDate);
							var hour = companyfaxdate.getHours() % 12;
							var newformat = companyfaxdate.getHours() >= 12 ? 'PM' : 'AM';
							var minuteStr = companyfaxdate.getMinutes() <= 9 ? "0" + companyfaxdate.getMinutes() : companyfaxdate.getMinutes();
							companyfaxdate = (companyfaxdate.getMonth()+1) + "/" + companyfaxdate.getDate() + "/" + companyfaxdate.getFullYear() + " " + hour + ":" + minuteStr + " " + newformat;
						}
						
					}
					
				}
			}
			
			
		}
		
		return (
			<FormControl component="fieldset" className={classes.formControl}>
				{/*<FormLabel component="legend">Assign responsibility</FormLabel> */}
				<FormGroup>
					{ (this.state.selectedPolice != null) && (
						<FormControlLabel
							control={<Checkbox checked={this.state.policeFaxCheck} onChange={() => { this.handleFaxCheckBoxChange('police') }} value={this.state.selectedPolice.fax} />}
							label={this.state.selectedPolice.departmentname + "  .  .  .  . " + this.state.selectedPolice.fax + "  .  .  .  . Status: " + policefaxstatus + "  .  .  .  .  at " + policefaxdate}
						/>)}
					{ (this.state.selectedCompanyProperty != null) && (
						<FormControlLabel
							control={<Checkbox checked={this.state.propertyFaxCheck} onChange={() => { this.handleFaxCheckBoxChange('property') }} value={this.state.selectedCompanyProperty.fax} />}
							label={this.state.selectedCompanyProperty.name + "  .  .  .  . " + this.state.selectedCompanyProperty.fax + "  .  .  .  . Status: " + propertyfaxstatus + "  .  .  .  .  at " + propertyfaxdate}
						/>)}
					{ (this.state.selectedStoragelot != null) && (
						<FormControlLabel
							control={
								<Checkbox checked={this.state.storageFaxCheck} onChange={() => { this.handleFaxCheckBoxChange('storage') }} value={this.state.selectedStoragelot.fax} />
							}
							label={this.state.selectedStoragelot.name + "  .  .  .  . " + this.state.selectedStoragelot.fax + "  .  .  .  . Status: " + storagefaxstatus + "  .  .  .  .  at " + storagefaxdate}
						/>)}
					{(this.state.fullCompanyInHere != null) && (<FormControlLabel
						control={<Checkbox checked={this.state.towFaxCheck} onChange={() => { this.handleFaxCheckBoxChange('tow') }} value={this.state.fullCompanyInHere.fax} />}
						label={this.state.fullCompanyInHere.name + "  .  .  .  . " + this.state.fullCompanyInHere.fax + "  .  .  .  . Status: " + companyfaxstatus + "  .  .  .  .  at " + companyfaxdate}
					/>)}
				</FormGroup>
				{/*<FormHelperText>Be careful</FormHelperText> */}
			</FormControl>
		)
		
		
		
	}
	
	
	
	
	
	renderEmailCheckBoxes() {
		const { classes } = this.props;
		var i = 0;
		
		var policeemailstatus = '-';
		var policeemaildate = '-';
		
		var propertyemailstatus = '-';
		var propertyemaildate = '-';
		
		var storageemailstatus = '-';
		var storageemaildate = '-';
		
		var companyemailstatus = '-';
		var companyemaildate = '-';
		
		if ((this.props.towEmailsArray != null) && (this.props.towEmailsArray != undefined)) {
			for (i = 0; i < this.props.towEmailsArray.length; i++) {
				
				var tempEmail = this.props.towEmailsArray[i];
				if ((tempEmail != null) && (this.state.selectedPolice !== null)) {
					
					if (tempEmail.recipientEmailAddress == this.state.selectedPolice.email) {
						
						policeemailstatus = tempEmail.status;
						
						var policeemaildate = "---";
						if (tempEmail.processedDate != null) {
							policeemaildate = new Date(tempEmail.processedDate);
							var hour = policeemaildate.getHours() % 12;
							var newformat = policeemaildate.getHours() >= 12 ? 'PM' : 'AM';
							var minuteStr = policeemaildate.getMinutes() <= 9 ? "0" + policeemaildate.getMinutes() : policeemaildate.getMinutes();
							policeemaildate = (policeemaildate.getMonth()+1) + "/" + policeemaildate.getDate() + "/" + policeemaildate.getFullYear() + " " + hour + ":" + minuteStr + " " + newformat;
						}
						//policeemaildate = tempEmail.processedDate;
						
					} else if((this.state.selectedCompanyProperty != null)&& (tempEmail.recipientEmailAddress == this.state.selectedCompanyProperty.email)) {
						
						propertyemailstatus = tempEmail.status;
						
						var propertyemaildate = "---";
						if (tempEmail.processedDate != null) {
							propertyemaildate = new Date(tempEmail.processedDate);
							var hour = propertyemaildate.getHours() % 12;
							var newformat = propertyemaildate.getHours() >= 12 ? 'PM' : 'AM';
							var minuteStr = propertyemaildate.getMinutes() <= 9 ? "0" + propertyemaildate.getMinutes() : propertyemaildate.getMinutes();
							propertyemaildate = (propertyemaildate.getMonth()+1) + "/" + propertyemaildate.getDate() + "/" + propertyemaildate.getFullYear() + " " + hour + ":" + minuteStr + " " + newformat;
						}
					} else if (tempEmail.recipientEmailAddress == this.state.selectedStoragelot.email) {
						
						storageemailstatus = tempEmail.status;
						
						var storageemaildate = "---";
						if (tempEmail.processedDate != null) {
							storageemaildate = new Date(tempEmail.processedDate);
							var hour = storageemaildate.getHours() % 12;
							var newformat = storageemaildate.getHours() >= 12 ? 'PM' : 'AM';
							var minuteStr = storageemaildate.getMinutes() <= 9 ? "0" + storageemaildate.getMinutes() : storageemaildate.getMinutes();
							storageemaildate = (storageemaildate.getMonth()+1) + "/" + storageemaildate.getDate() + "/" + storageemaildate.getFullYear() + " " + hour + ":" + minuteStr + " " + newformat;
						}
						
					} else if (tempEmail.recipientEmailAddress == this.state.fullCompanyInHere.email) {
						companyemailstatus = tempEmail.status;
						var companyemaildate = "---";
						if (tempEmail.processedDate != null) {
							companyemaildate = new Date(tempEmail.processedDate);
							var hour = companyemaildate.getHours() % 12;
							var newformat = companyemaildate.getHours() >= 12 ? 'PM' : 'AM';
							var minuteStr = companyemaildate.getMinutes() <= 9 ? "0" + companyemaildate.getMinutes() : companyemaildate.getMinutes();
							companyemaildate = (companyemaildate.getMonth()+1) + "/" + companyemaildate.getDate() + "/" + companyemaildate.getFullYear() + " " + hour + ":" + minuteStr + " " + newformat;
						}
						
					}
					
				}
			}
			
			
		}
		
		
		return (
			<FormControl component="fieldset" className={classes.formControlLabel} >
				{/*<FormLabel component="legend">Assign responsibility</FormLabel> */}
				<FormGroup>
					{ (this.state.selectedPolice != null) && (
						<FormControlLabel
							control={<Checkbox checked={this.state.policeEmailCheck} onChange={() => { this.handleEmailCheckBoxChange('police') }} value={this.state.selectedPolice.email} />}
							label={this.state.selectedPolice.departmentname + "  .  .  .  . " + this.state.selectedPolice.email + "  .  .  .  . Status: " + policeemailstatus + "  .  .  .  . at " + policeemaildate}
						/> )}
					{ (this.state.selectedCompanyProperty != null) && (
						<FormControlLabel component="legend" className={classes.formControlLabel}
						                  control={<Checkbox checked={this.state.propertyEmailCheck} onChange={() => { this.handleEmailCheckBoxChange('property') }} value={this.state.selectedCompanyProperty.email} />}
						                  
						                  label={
							                  this.state.selectedCompanyProperty.name + "  .  .  .  . " + this.state.selectedCompanyProperty.email + "  .  .  .  . Status: " + propertyemailstatus + "  .  .  .  . at " + propertyemaildate}
						/>)}
					{ (this.state.selectedStoragelot != null) && (
						<FormControlLabel
							control={
								<Checkbox checked={this.state.storageEmailCheck} onChange={() => { this.handleEmailCheckBoxChange('storage') }} value={this.state.selectedStoragelot.email} />
							}
							
							label={this.state.selectedStoragelot.name + "  .  .  .  . " + this.state.selectedStoragelot.email + "  .  .  .  . Status: " + storageemailstatus + "  .  .  .  . at " + storageemaildate}
						/> )}
					
					{(this.state.fullCompanyInHere != null) && (<FormControlLabel
						control={<Checkbox checked={this.state.towEmailCheck} onChange={() => { this.handleEmailCheckBoxChange('tow') }} value={this.state.fullCompanyInHere.email} />}
						label={this.state.fullCompanyInHere.name + "  .  .  .  . " + this.state.fullCompanyInHere.email + "  .  .  .  . Status: " + companyemailstatus + "  .  .  .  . at " + companyemaildate}
					/>)}
				
				</FormGroup>
				{/*<FormHelperText>Be careful</FormHelperText> */}
			</FormControl>
		)
		
		
		
	}
	
	
	
	handleModelChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ modelHelperText: '', modelError: false });
			
		} else {
			this.setState({ modelHelperText: 'Required', modelError: true });
		}
		this.setState(Object.assign(this.props.decodedVinVehicleObject, { model: event.target.value }));
	}
	handleMakeChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ makeHelperText: '', makeError: false });
			
		} else {
			this.setState({ makeHelperText: 'Required', makeError: true });
		}
		this.setState(Object.assign(this.props.decodedVinVehicleObject, { make: event.target.value }));
	}
	
	handleYearChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ yearHelperText: '', yearError: false });
			
		} else {
			this.setState({ yearHelperText: 'Required', yearError: true });
		}
		this.setState(Object.assign(this.props.decodedVinVehicleObject, { year: event.target.value }));
	}
	
	handleBodyChange(event) {
		if (event.target.value.length > 0) {
			this.setState({ bodyHelperText: '', bodyError: false });
			
		} else {
			this.setState({ bodyHelperText: 'Required', bodyError: true });
		}
		//event.preventDefault();
		this.setState(Object.assign(this.props.decodedVinVehicleObject, { body: event.target.value }));
	}
	
	handleTypeChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ typeHelperText: '', typeError: false });
			
		} else {
			this.setState({ typeHelperText: 'Required', typeError: true });
		}
		this.setState(Object.assign(this.props.decodedVinVehicleObject, { type: event.target.value }));
	}
	
	
	handleDoorsChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.props.decodedVinVehicleObject, { doors: event.target.value }));
	}
	
	
	//These are all police calls
	
	handlePoliceChiefnameChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ cheifnameHelperText: '', cheifnameError: false });
			
		} else {
			this.setState({ cheifnameHelperText: 'Required', cheifnameError: true });
		}
		this.setState(Object.assign(this.state.selectedPolice, { chiefname: event.target.value }));
	}
	
	handlePoliceDepartmentChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ policedepartmentHelperText: '', policedepartmentError: false });
			
		} else {
			this.setState({ policedepartmentHelperText: 'Required', policedepartmentError: true });
		}
		this.setState(Object.assign(this.state.selectedPolice, { departmentname: event.target.value }));
	}
	
	handlePoliceAddress2Change(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedPolice, { address2: event.target.value }));
	}
	
	handlePoliceAddress1Change(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ policedaddress1HelperText: '', policeaddress1Error: false });
			
		} else {
			this.setState({ policedaddress1HelperText: 'Required', policeaddress1Error: true });
		}
		this.setState(Object.assign(this.state.selectedPolice, { address1: event.target.value }));
	}
	
	
	handlePoliceCityChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ policecityHelperText: '', policecityError: false });
			
		} else {
			this.setState({ policecityHelperText: 'Required', policecityError: true });
		}
		this.setState(Object.assign(this.state.selectedPolice, { city: event.target.value }));
	}
	
	handlePoliceStateChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ policestateHelperText: '', policestateError: false });
			
		} else {
			this.setState({ policestateHelperText: 'Required', policestateError: true });
		}
		this.setState(Object.assign(this.state.selectedPolice, { state: event.target.value }));
	}
	
	handlePoliceCountryChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ policecountryHelperText: '', policecountryError: false });
			
		} else {
			this.setState({ policecountryHelperText: 'Required', policecountryError: true });
		}
		this.setState(Object.assign(this.state.selectedPolice, { country: event.target.value }));
	}
	
	handlePoliceZipcodeChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ policezipcodeHelperText: '', policezipcodeError: false });
			
		} else {
			this.setState({ policezipcodeHelperText: 'Required', policezipcodeError: true });
		}
		this.setState(Object.assign(this.state.selectedPolice, { zipcode: event.target.value }));
	}
	
	handlePoliceStateSelectionChange(event) {
		//this.setState({selectedState: event.target.value});
		if (event.target.value.length > 0) {
			this.setState({ policestateHelperText: '', policestateError: false });
			
		} else {
			this.setState({ policestateHelperText: 'Required', policestateError: true });
		}
		this.setState(Object.assign(this.state.selectedPolice, { state: event.target.value }));
		this.setState({ numberShrink: true });
	}
	
	handlePoliceCountrySelectionChange(event) {
		if (event.target.value.length > 0) {
			this.setState({ policecountryHelperText: '', policecountryError: false });
			
		} else {
			this.setState({ policecountryHelperText: 'Required', policecountryError: true });
		}
		this.setState(Object.assign(this.state.selectedPolice, { country: event.target.value }));
		
	}
	
	//End of Police calls
	
	handleVehicleStateSelectionChange(event) {
		//this.setState({selectedState: event.target.value});
		this.setState(Object.assign(this.state.selectedVehicle, { state: event.target.value }));
		this.setState({ numberShrink: true });
	}
	
	handleVehicleCountrySelectionChange(event) {
		this.setState(Object.assign(this.state.selectedVehicle, { country: event.target.value }));
		
	}
	
	
	
	
	//These are all Storagelot calls
	
	/*handlePoliceChiefnameChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ cheifnameHelperText: '', cheifnameError: false });
			
		} else {
			this.setState({ cheifnameHelperText: 'Required', cheifnameError: true });
		}
		this.setState(Object.assign(this.state.selectedPolice,{chiefname:event.target.value}));
	}*/
	
	/*handlePoliceDepartmentChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ policedepartmentHelperText: '', policedepartmentError: false });
			
		} else {
			this.setState({ policedepartmentHelperText: 'Required', policedepartmentError: true });
		}
		this.setState(Object.assign(this.state.selectedPolice,{departmentname:event.target.value}));
	}*/
	
	handleStoragelotAddress2Change(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedStoragelot, { address2: event.target.value }));
	}
	
	handleStoragelotAddress1Change(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ storlotaddress1HelperText: '', storlotaddress1Error: false });
			
		} else {
			this.setState({ storlotaddress1HelperText: 'Required', storlotaddress1Error: true });
		}
		this.setState(Object.assign(this.state.selectedStoragelot, { address1: event.target.value }));
	}
	
	
	handleStoragelotCityChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ storlotcityHelperText: '', storlotcityError: false });
			
		} else {
			this.setState({ storlotcityHelperText: 'Required', storlotcityError: true });
		}
		this.setState(Object.assign(this.state.selectedStoragelot, { city: event.target.value }));
	}
	
	handleStoragelotStateChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedStoragelot, { state: event.target.value }));
	}
	
	handleStoragelotCountryChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedStoragelot, { country: event.target.value }));
	}
	
	handleStoragelotZipcodeChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ storlotzipcodeHelperText: '', storlotzipcodeError: false });
			
		} else {
			this.setState({ storlotzipcodeHelperText: 'Required', storlotzipcodeError: true });
		}
		this.setState(Object.assign(this.state.selectedStoragelot, { zipcode: event.target.value }));
	}
	
	//End of Storagelot calls
	
	//These are all Company Property calls
	
	
	
	
	handleStoragelotEmailChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ storlotemailHelperText: '', storlotemailError: false });
			
		} else {
			this.setState({ storlotemailHelperText: 'Required', storlotemailError: true });
		}
		this.setState(Object.assign(this.state.selectedStoragelot, { email: event.target.value }));
	}
	
	
	handleCompanyPropertyEmailChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ locationemailHelperText: '', locationemailError: false });
			
		} else {
			this.setState({ locationemailHelperText: 'Required', locationemailError: true });
		}
		this.setState(Object.assign(this.state.selectedCompanyProperty, { email: event.target.value }));
	}
	
	handleCompanyPropertyAddress2Change(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedCompanyProperty, { address2: event.target.value }));
	}
	
	handleCompanyPropertyAddress1Change(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ locationaddress1HelperText: '', locationaddress1Error: false });
			
		} else {
			this.setState({ locationaddress1HelperText: 'Required', locationaddress1Error: true });
		}
		this.setState(Object.assign(this.state.selectedCompanyProperty, { address1: event.target.value }));
	}
	
	
	handleCompanyPropertyCityChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ locationcityHelperText: '', locationcityError: false });
			
		} else {
			this.setState({ locationcityHelperText: 'Required', locationcityError: true });
		}
		this.setState(Object.assign(this.state.selectedCompanyProperty, { city: event.target.value }));
	}
	
	handleCompanyPropertyStateChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ locationstateHelperText: '', locationstateError: false });
			
		} else {
			this.setState({ locationstateHelperText: 'Required', locationstateError: true });
		}
		this.setState(Object.assign(this.state.selectedCompanyProperty, { state: event.target.value }));
	}
	
	handleCompanyPropertyCountryChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ locationcountryHelperText: '', locationcountryError: false });
			
		} else {
			this.setState({ locationcountryHelperText: 'Required', locationcountryError: true });
		}
		this.setState(Object.assign(this.state.selectedCompanyProperty, { country: event.target.value }));
	}
	
	handleCompanyPropertyZipcodeChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ locationzipcodeHelperText: '', locationzipcodeError: false });
			
		} else {
			this.setState({ locationzipcodeHelperText: 'Required', locationzipcodeError: true });
		}
		this.setState(Object.assign(this.state.selectedCompanyProperty, { zipcode: event.target.value }));
	}
	
	handleCompanyPropertyStateSelectionChange(event) {
		//this.setState({selectedState: event.target.value});
		if (event.target.value.length > 0) {
			this.setState({ locationstateHelperText: '', locationstateError: false });
			
		} else {
			this.setState({ locationstateHelperText: 'Required', locationstateError: true });
		}
		this.setState(Object.assign(this.state.selectedCompanyProperty, { state: event.target.value }));
		this.setState({ numberShrink: true });
	}
	
	handleCompanyPropertyCountrySelectionChange(event) {
		if (event.target.value.length > 0) {
			this.setState({ locationcountryHelperText: '', locationcountryError: false });
			
		} else {
			this.setState({ locationcountryHelperText: 'Required', locationcountryError: true });
		}
		this.setState(Object.assign(this.state.selectedCompanyProperty, { country: event.target.value }));
		
	}
	
	handlePublicCompanyPropertyStateSelectionChange(event) {
		//this.setState({selectedState: event.target.value});
		if (event.target.value.length > 0) {
			this.setState({ locationstateHelperText: '', locationstateError: false });
			
		} else {
			this.setState({ locationstateHelperText: 'Required', locationstateError: true });
		}
		this.setState(Object.assign(this.state.selectedPublicpropertyStateHere, { state: event.target.value }));
		this.setState({ numberShrink: true });
	}
	
	handlePublicCompanyPropertyCountrySelectionChange(event) {
		if (event.target.value.length > 0) {
			this.setState({ locationcountryHelperText: '', locationcountryError: false });
			
		} else {
			this.setState({ locationcountryHelperText: 'Required', locationcountryError: true });
		}
		this.setState(Object.assign(this.state.selectedPublicpropertyStateHere, { country: event.target.value }));
		
	}
	//End of Company Property
	
	
	handleColorChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ colorHelperText: '', colorError: false });
			
		} else {
			this.setState({ colorHelperText: 'Required', colorError: true });
		}
		this.setState(Object.assign(this.state.selectedVehicle, { color: event.target.value }));
	}
	
	handlePlatenumberChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ plateHelperText: '', plateError: false });
			
		} else {
			this.setState({ plateHelperText: 'Required', plateError: true });
		}
		this.setState(Object.assign(this.state.selectedVehicle, { platenumber: event.target.value }));
	}
	
	handleVINChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ vinHelperText: '', vinError: false });
			
		} else {
			this.setState({ vinHelperText: 'Required', vinError: true });
		}
		let { decodeVin } = this.props;
		this.setState(Object.assign(this.state.selectedVehicle, { vin: event.target.value }));
		console.log("VIN is " + event.target.value);
		if (event != null) {
			if (event.target != null) {
				if (event.target.value.length == 17) {
					console.log(event.target.value);
					// FARSHID FOR NOW I  disabling this because I added a button for it. decodeVin(event.target.value);
				}
			}
		}
	}
	
	handleDecodeVin() {
		let { decodeVin } = this.props;
		decodeVin(this.state.selectedVehicle.vin);
	}
	
	
	handleSave = () => {
		console.log('saved', this.state.selectedDate.format('llll'));
	};
	
	handleStateChange(event) {
		//event.preventDefault();
		if (event.target.value.length > 0) {
			this.setState({ vehicleStateHelperText: '', vehicleStateError: false });
			
		} else {
			this.setState({ vehicleStateHelperText: 'Required', vehicleStateError: true });
		}
		this.setState(Object.assign(this.state.selectedVehicle, { state: event.target.value }));
	}
	
	handleMaterialDateChange(event) {
		//event.preventDefault();
		this.setState({ selectedMaterialDate: event });
	}
	
	
	handleDateChange(event) {
		//event.preventDefault();
		this.setState({ selectedDate: event });
	}
	
	handleRadioChange(event) {
		//event.preventDefault();
		this.setState({ selectedRadioButton: event.target.value });
	}
	
	/*
	clearFields = (e) => {
		e.preventDefault();
		this.setState(state => ({
			inputFieldShrinkYear:true
		}));
		
		
		var tempSelectedVehicle =   Object.assign({}, this.state.selectedVehicle);
		Object.keys(tempSelectedVehicle).map((key, index) => {
			tempSelectedVehicle[key] = "" ;
		});
		this.setState({selectedVehicle:tempSelectedVehicle})
		
	}; */
	
	
	
	renderErrorFiled(data) {
	
	
	}
	
	refresh(event) {
		let { loadVehiclesData } = this.props;
		loadVehiclesData(DEFAULT_VESPAAN_SERVER.url);
	}
	
	/*getListOfVehicles() {
		let tempArray = this.props.propertiesArray;
		let returnArray=[];
		if (tempArray) {
			returnArray = tempArray.map((s) => {
				return(<MenuItem key={s.id} value={s}>{s.name}</MenuItem>);
				//return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
			});
		}
		return(returnArray);
	}*/
	
	handleAuthorizedPersonChange(event) {
		//let { loadPoliceData,loadStoragelotsData, loadCompanypropertysData } = this.props;
		//event.preventDefault();
		this.setState({ selectedAuthorized: event.target.value });
		
	}
	
	handleCompanyPropertyChange(event) {
		//let { loadPoliceData,loadStoragelotsData, loadCompanypropertysData } = this.props;
		//event.preventDefault();
		this.setState({ selectedCompanyProperty: event.target.value });
		tempConst.length = 0;
		//tempConst=[];
		
	}
	
	handlePoliceChange(event) {
		//let { loadPoliceData,loadStoragelotsData, loadCompanypropertysData } = this.props;
		//event.preventDefault();
		this.setState({ selectedPolice: event.target.value });
		
	}
	
	handleStoragelotChange(event) {
		//let { loadPoliceData,loadStoragelotsData, loadCompanypropertysData } = this.props;
		//event.preventDefault();
		
		this.setState({ selectedStoragelot: event.target.value });
		
	}
	
	/*  4_22_2020 handleCompanyChange(event) {
	   let { loadPoliceData,loadStoragelotsData, loadCompanypropertysData, selectACompany,updateAPolicenoticePath } = this.props;
	   //event.preventDefault();
	   this.setState({selectedCompany:event.target.value});
	   loadPoliceData(DEFAULT_VESPAAN_SERVER.url,event.target.value.id );
	   loadStoragelotsData(DEFAULT_VESPAAN_SERVER.url, event.target.value.id);
	   loadCompanypropertysData(DEFAULT_VESPAAN_SERVER.url, event.target.value.id);
	   selectACompany(event.target.value.id);
	   this.props.changecompany(event.target.value.id);
	   updateAPolicenoticePath(DEFAULT_VESPAAN_SERVER.url,this.state.selectedCompany.id, "79926689-e452-4e60-8c51-85814058eb8e");
 
   }  */
	
	
	getListOfCompaniesForSelectionDidntwork() {
		let tempArray = this.props.companysArray;
		let returnArray = [];
		let tempReturnArray = [];
		let finalReturnArray = [];
		if (tempArray) {
			
			
			returnArray = tempArray.map((s) => {
				return (<option key={s.id} value={s}>{s.name}</option>);
				//return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
			});
			
			
		}
		
		
		return (returnArray);
	}
	
	clearFields = (e) => {
		e.preventDefault();
		this.setState(state => ({
			inputFieldShrinkState: true
		}));
		
		
		var tempSelectedStorage = Object.assign({}, this.state.selectedStoragelot);
		Object.keys(tempSelectedStorage).map((key, index) => { tempSelectedStorage[key] = ""; });
		
		var tempSelectedVehicle = Object.assign({}, this.state.selectedVehicle);
		Object.keys(tempSelectedVehicle).map((key, index) => { tempSelectedVehicle[key] = ""; });
		
		var tempSelectedPolice = Object.assign({}, this.state.selectedPolice);
		Object.keys(tempSelectedPolice).map((key, index) => { tempSelectedPolice[key] = ""; });
		
		var tempSelectedAuthorized = Object.assign({}, this.state.selectedAuthorized);
		Object.keys(tempSelectedAuthorized).map((key, index) => { tempSelectedAuthorized[key] = ""; });
		
		var tempSelectedCompanyProperty = Object.assign({}, this.state.selectedCompanyProperty);
		Object.keys(tempSelectedCompanyProperty).map((key, index) => { tempSelectedCompanyProperty[key] = ""; });
		
		var tempPublicSelectedCompanyProperty = Object.assign({}, this.state.selectedPublicpropertyStateHere);
		Object.keys(tempPublicSelectedCompanyProperty).map((key, index) => { tempPublicSelectedCompanyProperty[key] = ""; });
		
		
		
		
		
		this.setState({ clearFields: true });
		this.setState({ selectedStoragelot: tempSelectedStorage });
		this.setState({ selectedVehicle: tempSelectedVehicle });
		this.setState({ selectedPolice: tempSelectedPolice });
		this.setState({ selectedAuthorized: tempSelectedAuthorized });
		this.setState({ selectedCompanyProperty: tempSelectedCompanyProperty });
		this.setState({ selectedPublicpropertyStateHere: tempPublicSelectedCompanyProperty });
		this.setState(Object.assign(this.props.decodedVinVehicleObject, { year: "" }));
		this.setState(Object.assign(this.props.decodedVinVehicleObject, { body: "" }));
		this.setState(Object.assign(this.props.decodedVinVehicleObject, { type: "" }));
		this.setState(Object.assign(this.props.decodedVinVehicleObject, { make: "" }));
		this.setState(Object.assign(this.props.decodedVinVehicleObject, { model: "" }));
		
		this.setState({ selectedInvoice: "" });
		this.setState({ selectedNote: "" });
		this.setState({ seletedReason: [] });
		this.setState({ status: "" });
		//this.setState({selectedInvoice:""});
		//this.setState({selectedInvoice:""});
		
		this.setState({ faxButtonDisabled: true });
		this.setState({ emailButtonDisabled: true });
		this.setState({ noticeButtonDisabled: true });
		this.setState({ saveTowButtonDisabled: false });
		this.setState({ updateTowButtonDisabled: false });
		this.setState({ privatepropertynumber: false });
		
		
		
	};
	
	
	getListOfCompaniesForSelection() {
		let tempArray = this.props.companysArray;
		let returnArray = [];
		let tempReturnArray = [];
		let finalReturnArray = [];
		if (tempArray) {
			
			
			returnArray = tempArray.map((s) => {
				return (<MenuItem key={s.id} value={s}>{s.name}</MenuItem>);
				//return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
			});
			
			// tempReturnArray.push(<MenuItem key="1" value ="Select A Company"> <em>Select A Company</em>  </MenuItem>);
			
			// finalReturnArray = tempReturnArray.concat(returnArray);
			
			/*if(this.props.companysArray != null) {
				if (this.props.companysArray[1] != null) {
					returnArray.push( < MenuItem
					key = {this.props.companysArray[1].id}
					value = {this.props.companysArray[1].name} > < em > Select One Please < /em>  </
					MenuItem >
				)
					;
				}
			} */
			/*if(this.props.companysArray != null) {
				if(this.props.companysArray[0] != null) {
					this.setState({selectedCompany: this.props.companysArray[0]});
				}
			}*/
		}
		
		
		return (returnArray);
	}
	
	getSelectedCompnayFullInfo() {
		let tempArray = this.props.companysArray;
		for (var i = 0; i < tempArray.length; i++) {
			if (tempArray[i].id == this.props.selectedCompanyInHere) {
				this.setState({ fullCompanyInHere: tempArray[i] })
				
			}
		}
	}
	
	getListOfAuthorizedPeopleForSelection() {
		var tempArray1 = [];
		var returnArray1 = [];
		if ((this.state.selectedCompanyProperty != null) && (this.state.selectedCompanyProperty != undefined) && (this.state.selectedCompanyProperty.authorizedpeople != null)
			&& ((this.state.selectedCompanyProperty.authorizedpeople != undefined))) {
			//const var tempArray2=[];
			var tempJsonString1 = this.state.selectedCompanyProperty.authorizedpeople;
			if ((tempJsonString1 != null) && (tempJsonString1.length != 0)) {
				var jasonArray = JSON.parse(tempJsonString1);
				
				var tempArray2 = tempConst;
				//tempArray2.length=0;
				//let tempArray2  =new Array(0).fill(0);
				//tempArray1 = tempArray2.concat(jasonArray);
				var i = 0;
				for (i = 0; i < jasonArray.length; i++) {
					if (tempArray2.filter(function (e) {
						return e.name === jasonArray[i].name;
					}).length > 0) {
						/*notthing here */
					} else {
						tempArray2.push(jasonArray[i]);
					}
					
				}
				//tempArray1= tempArray2;
				
				if (tempArray2.length != 0) {
					
					returnArray1 = tempArray2.map((s) => {
						return (< MenuItem
							key={s.name + s.phone} value={s} > {s.name + " - " + s.phone} < /MenuItem>);
					});
				}
			}
		}
		return(returnArray1);
	}
	
	getListOfPoliceDepartmentsForSelection() {
		let tempArray = this.props.policeArray;
		let returnArray=[];
		if (tempArray) {
			returnArray = tempArray.map((s) => {
				return (<MenuItem key={s.id} value={s}>{s.departmentname}</MenuItem>);
				//return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
			});
		}
		//returnArray.push(<MenuItem key={"Other"} value={{ 'address2': '', 'address1': '', 'city': '', 'zipcode': '', 'name': 'Other' }}> Other</MenuItem>);
		return(returnArray);
	}
	
	getListOfPropertiesForSelection() {
		let tempArray = this.props.propertiesArray;
		let returnArray=[];
		if (tempArray) {
			returnArray = tempArray.map((s) => {
				return (<MenuItem key={s.id} value={s}>{s.address1 + " " + s.address2}</MenuItem>);
				//return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
			});
			
		}
		returnArray.push(<MenuItem key={"Other"} value={{ 'address2': '', 'address1': '', 'city': '', 'zipcode': '', 'name': 'Other' }}> Other</MenuItem>);
		return(returnArray);
	}
	
	getListOfStoragelotsForSelection() {
		let tempArray=[];
		tempArray= this.props.storagelotsArray;
		let returnArray=[];
		if (tempArray) {
			returnArray = tempArray.map((s) => {
				return (<MenuItem key={s.id} value={s} > {s.name}</MenuItem>);
				//return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
			});
		}
		//returnArray.push(<MenuItem key={"Other"} value={{ 'city': '', 'zipcode': '' }}> Other</MenuItem>);
		returnArray.push(<MenuItem key={"Other"} value={{ 'address2': '', 'address1': '', 'city': '', 'zipcode': '', 'name': 'Other' }}> Other</MenuItem>);
		
		return(returnArray);
	}
	
	handleInvoiceChange (event) {
		//setPersonName(event.target.value);
		this.setState({ selectedInvoice: event.target.value });
	};
	
	handleReasonChange (event) {
		//setPersonName(event.target.value);
		this.setState({ seletedReason: event.target.value });
	};
	
	handleReasonChangeMultiple (event){
		const { options} = event.target;
		const value = [];
		for (let i = 0, l = options.length; i < l;) {
			if (options[i].selected) {
				value.push(options[i].value);
			}
		}
		
		this.setState({seletedReason:value});
		//setPersonName(value);
	};
	
	hadleLoadedFile(argE, argFileName){
		const {uploadATowPicture} = this.props;
		
		//blob = fileReader.result;
		//new Blob([content], { type: "text/xml"});
		var blob = new Blob([argE.target.result]); //argE.target.result;
		var formData = new FormData();
		// It is of paramount importance for these to have the same name (the first paramater - here 'images')else multer will give you a very cryptic error
		formData.append("content", blob);
		//formData.append("images", img2);
		// you can of course append anything else you'd like
		formData.append("Description", "this is a test file");
		formData.append("FileType", argFileName.type);
		formData.append("CompanyId", this.props.selectedCompanyInHere);
		formData.append("Vin", this.state.selectedVehicle.vin.toUpperCase());
		formData.append("TowId", this.state.towId);
		formData.append("FileName", argFileName.name);
		
		uploadATowPicture(DEFAULT_VESPAAN_SERVER.url,formData ,this.props.selectedCompanyInHere);
		
	}
	
	
	handleUploadSelectedFile(file){
		const {uploadATowPicture} = this.props;
		//var blob="";
		const fileReader = new FileReader();
		//const name = target.accept.includes('image') ? 'images' : 'videos';
		var tempFile = this.state.chosenfile;
		//fileReader.readAsDataURL(event.target.value);
		fileReader.readAsArrayBuffer(file); //readAsBinaryString(file);//
		fileReader.onload =(e)=>{this.hadleLoadedFile(e, file)};
	};
	
	
	
	
	/*
	handleUploadTest(event){
		const {uploadATowPicture} = this.props;
		//uploadATowPicture(argURL, argFormData, argCompanyId)
		 let img1 = "../../../images/env1.jpg";
		 //let img2 = "../../images/env2.jpg";
		var content = '<a id="a"><b id="b">hey!</b></a>'; // the body of the new file...
		//var blob = new Blob([content], { type: "text/xml"});
		var filename = event.target.files[0].name;
		const formData = new FormData();
		// It is of paramount importance for these to have the same name (the first paramater - here 'images')else multer will give you a very cryptic error
		 formData.append("content", filename);
		 //formData.append("images", img2);
			// you can of course append anything else you'd like
		formData.append("joke", "this is a poor mama joke");
		uploadATowPicture(DEFAULT_VESPAAN_SERVER.url,formData ,this.props.selectedCompany);
	} */
	
	handleWebSocketActionChange (event) {
		
		
		this.stompClient.send("/app/chat/99999", {},
			JSON.stringify({ 'from': "farshid", 'text': "Hello Buddy" }));
		
		
		
		
	};
	
	onRadioChangeValue(event) {
		console.log(event.target.value);
		this.setState({locationtype:event.target.value});
	}
	
	render() {
		const {classes, updateAPolicenoticePath} = this.props;
		let usStates = MainConstants.getUSStates();
		let canStates = MainConstants.getCanadaStates();
		let availableCountries = MainConstants.getCountries();
		let actionList = MainConstants.getActionList();
		
		
		let faxBoxes =  this.renderFaxCheckBoxes();
		let emailBoxes = this.renderEmailCheckBoxes();
		
		
		this.companyPropertyList = this.getListOfPropertiesForSelection();
		this.companySelectList = this.getListOfCompaniesForSelection();
		this.policeSelectList = this.getListOfPoliceDepartmentsForSelection();
		this.storagelotsSelectList = this.getListOfStoragelotsForSelection();
		this.peopleList = this.getListOfAuthorizedPeopleForSelection();
		//var filePath = updateAPolicenoticePath(DEFAULT_VESPAAN_SERVER.url,this.state.selectedCompany.id, "c63d2128-4197-40b4-a30f-6f930f6b132a");
		
		return (
			
			<React.Fragment>
				<Typography variant="h6" gutterBottom align="center">
					Tow Information for {this.state.privatepropertynumber}
				</Typography>
				
				{/*

            <Grid container >
                <Grid item xs={12} sm={12}>
                    <Divider className={classes.dividerColor}></Divider>
                </Grid>
            </Grid>


            <Grid container >
                <Grid item xs={12} sm={12}>
                    <Divider className={classes.dividerColor1}></Divider>
                </Grid>
            </Grid>

            */}
				
				
				<Grid container  style={{paddingLeft:20}}>
					
					
					<Grid item xs={3} sm={3} >
						{(this.state.selectedRadioButton == "Preconfigured") && (
							<FormControl className={classes.formControl}>
								<InputLabel htmlFor="age-helper">Private Property</InputLabel>
								<Select
									value={this.state.selectedCompanyProperty}
									onChange={(e)=>this.handleCompanyPropertyChange(e)}
									inputProps={{
										name: 'property',
										id: 'property-helper',
									}}
								>
									
									{this.companyPropertyList}
								
								</Select>
							
							</FormControl>
						)}
					</Grid>
					
					<Grid item xs={3} sm={3} >
						
						{(this.state.selectedRadioButton == "Preconfigured") && (
							<FormControl className={classes.formControl}>
								<InputLabel htmlFor="age-helper">Authorized By</InputLabel>
								<Select
									value={this.state.selectedAuthorized}
									onChange={this.handleAuthorizedPersonChange}
									inputProps={{
										name: 'person',
										id: 'person-helper',
									}}
								>
									
									{this.peopleList}
								
								</Select>
							
							</FormControl>
						)}
					
					</Grid>
					<Grid item xs={3} sm={3}>
						<FormControl className={classes.formControl}>
							<InputLabel htmlFor="age-helper">Storage Lot</InputLabel>
							<Select
								value={this.state.selectedStoragelot}
								onChange={this.handleStoragelotChange}
								inputProps={{
									name: 'lot',
									id: 'storagelot-select',
								}}
							>
								
								{this.storagelotsSelectList}
							
							</Select>
							{/* <FormHelperText>Select a Company </FormHelperText>  */}
						</FormControl>
					
					</Grid>
					<Grid item xs={3} sm={3}>
						<FormControl className={classes.formControl} required>
							<InputLabel htmlFor="age-helper">Police</InputLabel>
							<Select
								id="policeselect"
								ref="policeselect"
								value={this.state.selectedPolice}
								onChange={(e) => { this.handlePoliceChange(e) }}
								inputProps={{
									name: 'police',
									id: 'policeselect',
								}}>
								
								{this.policeSelectList}
							
							</Select>
							{/* <FormHelperText>Select a Company </FormHelperText>  */}
						</FormControl>
					
					</Grid>
					{/*This si action list
        <Grid item xs={4} sm={4} >

            { (this.state.selectedRadioButton == "Preconfigured") && (
            <FormControl className={classes.formControl}>
            <InputLabel htmlFor="age-helper">Actions</InputLabel>
                <Select
                value={this.state.selectedActionOne}
                onChange={this.handleActionChange}
                    inputProps={{
                        name: 'age',
                            id: 'age-helper',
                    }}>

                {actionList}

                </Select>

            </FormControl>
            )}

        </Grid>  */}
					
					{/* this was for  websocket operation or updates
									<Grid item xs={4} sm={4} >
										<FormControlLabel
											control={<PurpleSwitch className={classes.switchColor} onChange={() => { this.handleWebSocketActionChange() }} />}
											label={"Web_Socket_testing "}
										/>
									</Grid>
									
						*/}
					
					
					
					
					{/* This was not  okay}
					<Grid item xs={4} sm={4} >
					<input
				color="primary"
				accept="image/*"
				type="file"
				onChange={this.handleUploadTest}
				id="icon-button-file"
				style={{ display: 'none', }}
				/>
				<label htmlFor="icon-button-file">
					<Button
				variant="contained"
				component="span"
				className={classes.button}
				size="large"
				color="primary"
					>
					Upload files
				</Button>
				</label>
						</Grid>
						*/}
					
					
					{/* for WebSocket testing
					
									<Grid item xs={4} sm={4} >
										<FormControlLabel
											control={<PurpleSwitch className={classes.switchColor} onChange={() => { this.handleUploadTest() }} />}
											label={"Websockettesting "}
										/>
									</Grid>
									
									*/}
					
					
					{/*
        <Grid item xs={4} sm={4} >
            <FormControlLabel
        control={<PurpleSwitch   className={classes.switchColor}  checked={this.state.editMode} onChange={() => {this.handleEditModeChange()}} />}
        label= { "Add Tow"}
        />
            </Grid>
            */}
				
				</Grid>
				
				
				{/*
            <Grid item xs={12} sm={12}>
                <Divider className={classes.dividerColorPurpole}></Divider>
                <br/>
            </Grid>
            */}
				<br />
				
				<Grid item xs={12} sm={12}>
					<Divider className={classes.dividerColorPurpole}></Divider>
				</Grid>
				<Grid item xs={12} sm={12}>
					<Divider className={classes.dividerColorPurpole}></Divider>
				
				</Grid>
				<Grid container spacing={24}  style={{paddingLeft:20}}>
					<Grid item xs={2} sm={2}>
						<Typography variant="subtitle1" gutterBottom>
							Vehicle:
						</Typography>
					</Grid>
					<Grid item xs={2} sm={2}>
						<Button variant="contained" color="primary" className={classes.button} onClick={(event) => this.handleDecodeVin()} >
							Decode VIN
						</Button>
					</Grid>
					{((this.props.decodedVinVehicleObject.errorCode != 0) && (this.props.decodedVinVehicleObject != undefined) && (this.props.decodedVinVehicleObject.errorCode != undefined)) && (
						
						<Grid item xs={8} sm={8} >
							<Typography variant="subtitle1" color='secondary' gutterBottom>
								VIN decoding failed, please check the VIN and try again.  Error:  {this.props.decodedVinVehicleObject.errorText}
							</Typography>
						</Grid>)}
					{((this.props.decodedVinVehicleObject.errorCode == 0) || (this.props.decodedVinVehicleObject == undefined) || (this.props.decodedVinVehicleObject.errorCode == undefined)) && (
						
						<Grid item xs={8} sm={8} >
							<Typography variant="subtitle1" gutterBottom>
							
							</Typography>
						</Grid>)}
				
				
				</Grid>
				<Grid container spacing={24} style={{paddingLeft:20}}>
					
					<Grid item xs={4} sm={4}>
						<TextField id="vinnumber" name="vinnumber" label="VIN" fullWidth error={this.state.vinError} helperText={this.state.vinHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} autoCapitalize='on' value={this.state.selectedVehicle.vin} onChange={this.handleVINChange} />
					</Grid>
					
					
					
					
					
					
					<Grid item xs={4} sm={4} >
						<TextField id="body" name="body" label="Body" fullWidth error={this.state.bodyError} helperText={this.state.bodyHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.props.decodedVinVehicleObject.body} onChange={this.handleBodyChange} />
					</Grid>
					
					
					<Grid item xs={4} sm={4} >
						<TextField required id="type" name="type" label="Type" fullWidth error={this.state.typeError} helperText={this.state.typeHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.props.decodedVinVehicleObject.type} onChange={this.handleTypeChange} />
					</Grid>
					
					
					
					{/*
        <Grid item xs={3} sm={3}>
            <TextField id="plateNumber" name="plateNumber" label="PlateNumber" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }}  value={this.state.selectedVehicle.platenumber} onChange={this.handlePlatenumberChange} />
        </Grid>
        */}
					
					
					<Grid item xs={12} sm={12}>
						
						
						
						<Grid container spacing={24}>
							<Grid item xs={12} sm={12}>
								{/*
                    <Grid container >
                            <Grid item xs={5} sm={5}>
                            <TextField  required id="make"  name="make"  label="Make"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }}  value={this.props.decodedVinVehicleObject.make} onChange={this.handleMakeChange} />
                                </Grid>
                        <Grid item xs={2} sm={2} >
                            </Grid>
                        <Grid item xs={5} sm={5} >
                            <TextField required id="model" name="model"  label="Model"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }}  value={this.props.decodedVinVehicleObject.model} onChange={this.handleModelChange}/>
                        </Grid>

                    </Grid>
                    */}
								
								<Grid container spacing={24} >
									
									
									
									<Grid item xs={4} sm={4} >
										<TextField id="year" name="year" label="Year" fullWidth error={this.state.yearError} helperText={this.state.yearHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.props.decodedVinVehicleObject.year} onChange={this.handleYearChange} />
									</Grid>
									
									
									
									<Grid item xs={4} sm={4}>
										<TextField required id="make" name="make" label="Make" fullWidth error={this.state.makeError} helperText={this.state.makeHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.props.decodedVinVehicleObject.make} onChange={this.handleMakeChange} />
									</Grid>
									
									<Grid item xs={4} sm={4} >
										<TextField required id="model" name="model" label="Model" fullWidth error={this.state.modelError} helperText={this.state.modelHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.props.decodedVinVehicleObject.model} onChange={this.handleModelChange} />
									</Grid>
								
								</Grid>
								
								{/*
        <Grid container >

        <Grid item xs={5} sm={5} >
            <TextField id="body" name="body" label="Body" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }}  value={this.props.decodedVinVehicleObject.body} onChange={this.handleBodyChange}/>
        </Grid>

        <Grid item xs={2} sm={2} >
            </Grid>

            <Grid item xs={5} sm={5} >
            <TextField required id="doors" name="doors" label="Doors" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }}  value={this.props.decodedVinVehicleObject.doors} onChange={this.handleDoorsChange}/>
        </Grid>
        </Grid>
         */}
								
								<Grid container spacing={24} >
									
									<Grid item xs={3} sm={3} >
										{/*<TextField required id="city" name="city" label="City" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedProperty.city} onChange={this.handleCityChange}/>
                                       */}
										<FormControl className={classes.formControl}>
											<InputLabel htmlFor="age-helper">Country</InputLabel>
											<Select value={this.state.selectedVehicle.country}
											        onChange={this.handleVehicleCountrySelectionChange}
											        inputProps={{
												        name: 'country',
												        id: 'country-helper',
											        }}
											>
												
												{availableCountries}
											
											</Select>
										
										</FormControl>
									
									
									</Grid>
									
									
									<Grid item xs={3} sm={3} >
										<FormControl className={classes.formControl}>
											<InputLabel htmlFor="age-helper">State</InputLabel>
											<Select value={this.state.selectedVehicle.state}
											        onChange={this.handleVehicleStateSelectionChange}
											        inputProps={{
												        name: 'state',
												        id: 'state-helper',
											        }}
											>
												
												{(this.state.selectedVehicle.country == "U.S.A") && (usStates)}
												{(this.state.selectedVehicle.country != "U.S.A") && (canStates)}
											
											
											</Select>
											{/* <FormHelperText>Select a State </FormHelperText> */}
										</FormControl>
									
									</Grid>
									
									<Grid item xs={3} sm={3} >
										<TextField id="color" name="color" label="Color" fullWidth error={this.state.colorError} helperText={this.state.colorHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedVehicle.color} onChange={this.handleColorChange} />
									</Grid>
									
									
									<Grid item xs={3} sm={3}>
										<TextField id="plateNumber" name="plateNumber" label="PlateNumber" fullWidth error={this.state.plateError} helperText={this.state.plateHelperText} inputProps={{ textTransform: 'uppercase', color: '#054659' }} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedVehicle.platenumber} onChange={this.handlePlatenumberChange} />
									</Grid>
									
									
									<Grid item xs={12} sm={12}>
										<br />
									</Grid>
								</Grid>
								
								<Grid container >
									<Grid container >
										<Grid item xs={12} sm={12}>
											<Divider className={classes.dividerColor}></Divider>
										</Grid>
									</Grid>
									
									
									
									<Grid container >
										<Grid item xs={12} sm={12}>
											<Divider className={classes.dividerColor}></Divider>
										</Grid>
									</Grid>
									
									<Grid item xs={2} sm={2} >
										<Typography variant="subtitle1" gutterBottom>
											Reason:
										</Typography>
									</Grid>
									
									<Grid item xs={7} sm={7}  style={{width:'80%'}}>
										<FormControl className={classes.formControl}>
											<InputLabel id="demo-mutiple-checkbox-label" shrink={true} >Cause</InputLabel>
											<Select
												labelId="demo-mutiple-checkbox-label"
												id="demo-mutiple-checkbox"
												multiple
												value={this.state.seletedReason}
												onChange={this.handleReasonChange}
												input={<Input />}
												renderValue={selected => selected.join(', ')}
												MenuProps={MenuProps}
											>
												{names.map(name => (
													<MenuItem key={name} value={name}>
														<Checkbox checked={this.state.seletedReason.indexOf(name) > -1} />
														<ListItemText primary={name} />
													</MenuItem>
												))}
											</Select>
										</FormControl>
									
									</Grid>
									
									<Grid item xs={1} sm={1} style={{flexDirection:'row'}} >
										
										<Typography variant="subtitle1" gutterBottom  >
											Status:
										</Typography>
									
									
									</Grid>
									
									<Grid item xs={2} sm={2}  >
										<Typography variant="subtitle1" gutterBottom  style={{fontWeight:'600'}} >
											{this.state.status}
										</Typography>
									
									</Grid>
									
									
									<Grid item xs={12} sm={12}>
										<TextField id="note" name="note" label="Note" fullWidth error={this.state.noteError} helperText={this.state.noteHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedNote} onChange={this.handleNoteChange} />
									</Grid>
									
									<br />
									
									
									<Grid item xs={12} sm={12}>
										<TextField id="invoice" name="invoice" label="Invoice" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedInvoice} onChange={this.handleInvoiceChange} />
									</Grid>
									
									
									<Grid item xs={12} sm={12}>
										<br />
									</Grid>
									
									
									
									
									
									<Grid item xs={12} sm={12}>
										<Divider className={classes.dividerColor}></Divider>
									</Grid>
								</Grid>
								
								
								<FormControl component="fieldset">
									<FormLabel component="legend" style={{   color:'black'}}>Location: </FormLabel>
									<RadioGroup aria-label="gender" name="gender1" value={this.state.locationtype} onChange={this.onRadioChangeValue} style={{   flexDirection:'row'}}>
										<FormControlLabel value="private" control={<Radio  color="primary"/>} label="Private Property"    />
										<FormControlLabel value="public" control={<Radio  color="primary"/>} label="Public Place" />
									</RadioGroup>
								</FormControl>
								
								
								{(this.state.locationtype != null) &&  (this.state.locationtype == "private") &&(
									< ExpansionPanel >
										< ExpansionPanelSummary expandIcon={< ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header" >
											<Typography variant="subtitle1" > Private Location:  </Typography> &nbsp; &nbsp;
											< Typography variant="body2" className={classes.typoTopMargin}>  {this.state.selectedCompanyProperty.name} - {this.state.selectedCompanyProperty.address1} {this.state.selectedCompanyProperty.address2}, {this.state.selectedCompanyProperty.city},
												{this.state.selectedCompanyProperty.state} {this.state.selectedCompanyProperty.zipcode}  </Typography>
										< /ExpansionPanelSummary>
										< ExpansionPanelDetails >
											
											
											<Grid container spacing={24}>
												<Grid item xs={7} sm={7}>
													<TextField id="address1" name="address1" label="Address1" fullWidth error={this.state.locationaddress1Error} helperText={this.state.locationaddress1HelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedCompanyProperty.address1} onChange={this.handleCompanyPropertyAddress1Change} />
												</Grid>
												
												<Grid item xs={3} sm={3}>
													<TextField required id="address2" name="address2" label="Address2" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedCompanyProperty.address2} onChange={this.handleCompanyPropertyAddress2Change} />
												</Grid>
												
												<Grid item xs={2} sm={2} >
													<TextField required id="email1" name="email1" label="Email " fullWidth error={this.state.locationemailError} helperText={this.state.locationemailHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedCompanyProperty.email} onChange={this.handleCompanyPropertyEmailChange} />
												
												</Grid>
												
												
												<Grid item xs={3} sm={3}>
													<TextField required id="City" name="city" label="City" fullWidth error={this.state.locationcityError} helperText={this.state.locationcityHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedCompanyProperty.city} onChange={this.handleCompanyPropertyCityChange} />
												</Grid>
												
												<Grid item xs={3} sm={3} >
													<FormControl className={classes.formControl}>
														<InputLabel htmlFor="age-helper">State</InputLabel>
														<Select value={this.state.selectedCompanyProperty.state} onChange={this.handleCompanyPropertyStateSelectionChange}
														        inputProps={{
															        name: 'state',
															        id: 'state-helper',
														        }} >
															
															{(this.state.selectedCompanyProperty.country == "U.S.A") && (usStates)}
															{(this.state.selectedCompanyProperty.country != "U.S.A") && (canStates)}
														</Select>
														{/* <FormHelperText>Select a State </FormHelperText> */}
													</FormControl>
												</Grid>
												
												
												
												
												<Grid item xs={2} sm={2}>
													<TextField required id="zipcode" name="zipcode" label="Zip Code" fullWidth error={this.state.locationzipcodeError} helperText={this.state.locationzipcodeHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedCompanyProperty.zipcode} onChange={this.handleCompanyPropertyZipcodeChange} />
												</Grid>
												
												<Grid item xs={3} sm={3} >
													{/*<TextField required id="city" name="city" label="City" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedProperty.city} onChange={this.handleCityChange}/>
                                                   */}
													<FormControl className={classes.formControl}>
														<InputLabel htmlFor="age-helper">Country</InputLabel>
														<Select value={this.state.selectedCompanyProperty.country}
														        onChange={this.handleCompanyPropertyCountrySelectionChange}
														        inputProps={{
															        name: 'country',
															        id: 'country-helper',
														        }}
														>
															
															{availableCountries}
														
														</Select>
													</FormControl>
												</Grid>
											
											</Grid>
										< /ExpansionPanelDetails>
									< /ExpansionPanel>)}
								
								
								{/* This is when public location we read it off of the Towjob */}
								{(this.state.locationtype != null) &&  (this.state.locationtype == "public")   &&(
									< ExpansionPanel >
										{/*}
												< ExpansionPanelSummary expandIcon={< ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header" >
													<Typography variant="subtitle1" >Public Location:  </Typography> &nbsp; &nbsp;
												< Typography variant="body2" className={classes.typoTopMargin}>  {this.state.selectedPublicpropertyStateHere.name} - {this.state.selectedPublicpropertyStateHere.address1} {this.state.selectedPublicpropertyStateHere.address2}, {this.state.selectedPublicpropertyStateHere.city},
													{this.state.selectedPublicpropertyStateHere.state} {this.state.selectedPublicpropertyStateHere.zipcode}  </Typography>
												< /ExpansionPanelSummary>
												*/}
										< ExpansionPanelDetails >
											
											
											<Grid container spacing={24}>
												<Grid item xs={7} sm={7}>
													<TextField id="address1" name="address1" label="Address1" fullWidth error={this.state.locationaddress1Error} helperText={this.state.locationaddress1HelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedPublicpropertyStateHere.address1} onChange={this.handlePublicAddressChange} />
												</Grid>
												
												<Grid item xs={3} sm={3}>
													{/*}
													<TextField required id="address2" name="address2" label="Address2" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.props.passedTowJob.locationaddress2} onChange={this.handleCompanyPropertyAddress2Change} />
													*/}
												</Grid>
												{/*
												<Grid item xs={2} sm={2} >
													<TextField required id="email1" name="email1" label="Email " fullWidth error={this.state.locationemailError} helperText={this.state.locationemailHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedCompanyProperty.email} onChange={this.handleCompanyPropertyEmailChange} />
												
												</Grid> */}
												
												
												<Grid item xs={3} sm={3}>
													<TextField required id="City" name="city" label="City" fullWidth error={this.state.locationcityError} helperText={this.state.locationcityHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedPublicpropertyStateHere.city} onChange={this.handlePublicCityChange} />
												</Grid>
												
												<Grid item xs={3} sm={3} >
													<FormControl className={classes.formControl}>
														<InputLabel htmlFor="age-helper">State</InputLabel>
														<Select value={this.state.selectedPublicpropertyStateHere.state} onChange={this.handlePublicCompanyPropertyStateSelectionChange}
														        inputProps={{
															        name: 'state',
															        id: 'state-helper',
														        }} >
															
															{(this.state.selectedPublicpropertyStateHere.country == "U.S.A") && (usStates)}
															{(this.state.selectedPublicpropertyStateHere.country != "U.S.A") && (canStates)}
														</Select>
														{/* <FormHelperText>Select a State </FormHelperText> */}
													</FormControl>
												</Grid>
												
												
												
												
												<Grid item xs={2} sm={2}>
													<TextField required id="zipcode" name="zipcode" label="Zip Code" fullWidth error={this.state.locationzipcodeError} helperText={this.state.locationzipcodeHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedPublicpropertyStateHere.zipcode} onChange={this.handlePublicZipcodeChange} />
												</Grid>
												
												<Grid item xs={3} sm={3} >
													{/*<TextField required id="city" name="city" label="City" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedProperty.city} onChange={this.handleCityChange}/>
                                                   */}
													<FormControl className={classes.formControl}>
														<InputLabel htmlFor="age-helper">Country</InputLabel>
														<Select value={this.state.selectedPublicpropertyStateHere.country}
														        onChange={this.handlePublicCompanyPropertyCountrySelectionChange}
														        inputProps={{
															        name: 'country',
															        id: 'country-helper',
														        }}
														>
															
															{availableCountries}
														
														</Select>
													</FormControl>
												</Grid>
											
											</Grid>
										< /ExpansionPanelDetails>
									< /ExpansionPanel>)}
								
								{/* End of location form */}
								
								{/*<Grid item xs={12} sm={12}>
        
        </Grid>*/}
								
								
								{/* </Grid>  */}
								
								
								{/* begning of  area for the  storage lot  */}
								
								
								
								
								<Grid container   >
									<Grid item xs={12} sm={12}>
										<Divider className={classes.dividerColor}></Divider>
									</Grid>
								</Grid>
								{(this.state.selectedStoragelot !== null ) &&
									< ExpansionPanel >
										
										< ExpansionPanelSummary expandIcon={< ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header" >
											<Typography variant="subtitle1" >Storage Lot: </Typography>   &nbsp; &nbsp;
											< Typography variant="body2">{this.state.selectedStoragelot.name} - {this.state.selectedStoragelot.address1} {this.state.selectedStoragelot.address2} {this.state.selectedStoragelot.city},
												{this.state.selectedStoragelot.state} {this.state.selectedStoragelot.zipcode}  </Typography>
										< /ExpansionPanelSummary>
										< ExpansionPanelDetails >
											
											
											
											<Grid container spacing={24}>
												
												<Grid item xs={7} sm={7}>
													<TextField id="address1" name="address1" label="Address1" fullWidth error={this.state.storlotaddress1Error} helperText={this.state.storlotaddress1HelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedStoragelot.address1} onChange={this.handleStoragelotAddress1Change} />
												</Grid>
												
												<Grid item xs={3} sm={3}>
													<TextField id="address2" name="address2" label="Address2" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedStoragelot.address2} onChange={this.handleStoragelotAddress2Change} />
												</Grid>
												
												<Grid item xs={2} sm={2} >
													<TextField id="email3" name="email3" label="Email" fullWidth error={this.state.storlotemailError} helperText={this.state.storlotemailHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedStoragelot.email} onChange={this.handleStoragelotEmailChange} />
												
												</Grid>
												
												<Grid item xs={3} sm={3}>
													<TextField required id="City" name="city" label="City" fullWidth error={this.state.storlotcityError} helperText={this.state.storlotcityHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedStoragelot.city} onChange={this.handleStoragelotCityChange} />
												</Grid>
												
												<Grid item xs={3} sm={3} >
													<FormControl className={classes.formControl}>
														<InputLabel htmlFor="age-helper">State</InputLabel>
														<Select value={this.state.selectedStoragelot.state} onChange={this.handleStoragelotStateSelectionChange}
														        inputProps={{
															        name: 'state',
															        id: 'state-helper',
														        }} >
															
															{(this.state.selectedStoragelot.country == "U.S.A") && (usStates)}
															{(this.state.selectedStoragelot.country != "U.S.A") && (canStates)}
														</Select>
														{/* <FormHelperText>Select a State </FormHelperText> */}
													</FormControl>
												</Grid>
												
												
												<Grid item xs={3} sm={3}>
													<TextField required id="zipcode" name="zipcode" label="Zip Code" fullWidth error={this.state.storlotzipcodeError} helperText={this.state.storlotzipcodeHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedStoragelot.zipcode} onChange={this.handleStoragelotZipcodeChange} />
												</Grid>
												
												<Grid item xs={3} sm={3} >
													{/*<TextField required id="city" name="city" label="City" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedProperty.city} onChange={this.handleCityChange}/>
                                                   */}
													<FormControl className={classes.formControl}>
														<InputLabel htmlFor="age-helper">Country</InputLabel>
														<Select value={this.state.selectedStoragelot.country}
														        onChange={this.handleStoragelotCountrySelectionChange}
														        inputProps={{
															        name: 'country',
															        id: 'country-helper',
														        }}
														>
															{availableCountries}
														
														</Select>
													</FormControl>
												</Grid>
											
											</Grid>
										< /ExpansionPanelDetails>
									< /ExpansionPanel> }
								
								
								
								
								
								
								<Grid container >
									<Grid item xs={12} sm={12}>
										<Divider className={classes.dividerColor}></Divider>
									</Grid>
								</Grid>
								
								
								
								{/* End of area for company and storage */}
								
								{/* begning of  area for the police  */}
								
								{(this.state.selectedPolice !== null ) &&
									< ExpansionPanel >
										< ExpansionPanelSummary expandIcon={< ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header" >
											<Typography variant="subtitle1" >Police:    </Typography>    &nbsp; &nbsp;
											< Typography variant="body2">  {this.state.selectedPolice.departmentname}  -  {this.state.selectedPolice.address1} {this.state.selectedPolice.address2}  {this.state.selectedPolice.city},
												{this.state.selectedPolice.state} {this.state.selectedPolice.zipcode}  - Fax : {this.state.selectedPolice.fax}< /Typography>
										< /ExpansionPanelSummary>
										< ExpansionPanelDetails >
											
											
											
											<Grid container spacing={24} >
												<Grid item xs={5} sm={5}>
													<TextField required id="chiefname" name="chiefname" label="Chief" fullWidth error={this.state.cheifnameError} helperText={this.state.cheifnameHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedPolice.chiefname} onChange={this.handlePoliceChiefnameChange} />
												</Grid>
												<Grid item xs={2} sm={2} >
												</Grid>
												<Grid item xs={5} sm={5}>
													<TextField required id="departmentname" name="departmentname" label="Department" fullWidth error={this.state.policedepartmentError} helperText={this.state.policedepartmentHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedPolice.departmentname} onChange={this.handlePoliceDepartmentChange} />
												</Grid>
												
												<Grid item xs={8} sm={8}>
													<TextField id="address1" name="address1" label="Address1" fullWidth error={this.state.policeaddress1Error} helperText={this.state.policedaddress1HelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedPolice.address1} onChange={this.handlePoliceAddress1Change} />
												</Grid>
												<Grid item xs={1} sm={1} >
												</Grid>
												<Grid item xs={3} sm={3}>
													<TextField id="address2" name="address2" label="Address2" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedPolice.address2} onChange={this.handlePoliceAddress2Change} />
												</Grid>
												
												
												
												
												
												<Grid item xs={3} sm={3} >
													{/*<TextField required id="city" name="city" label="City" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedProperty.city} onChange={this.handleCityChange}/>
                                           */}
													<FormControl className={classes.formControl}>
														<InputLabel htmlFor="age-helper">Country</InputLabel>
														<Select value={this.state.selectedPolice.country}
														        onChange={this.handlePoliceCountrySelectionChange}
														        inputProps={{
															        name: 'country',
															        id: 'country-helper',
														        }}
														>
															
															{availableCountries}
														
														</Select>
													</FormControl>
												</Grid>
												
												
												<Grid item xs={3} sm={3} >
													<FormControl className={classes.formControl}>
														<InputLabel htmlFor="age-helper">State</InputLabel>
														<Select value={this.state.selectedPolice.state} onChange={this.handlePoliceStateSelectionChange}
														        inputProps={{
															        name: 'state',
															        id: 'state-helper',
														        }} >
															
															{(this.state.selectedPolice.country == "U.S.A") && (usStates)}
															{(this.state.selectedPolice.country != "U.S.A") && (canStates)}
														</Select>
														{/* <FormHelperText>Select a State </FormHelperText> */}
													</FormControl>
												</Grid>
												
												<Grid item xs={3} sm={3}>
													<TextField required id="City" name="city" label="City" fullWidth error={this.state.policecityError} helperText={this.state.policecityHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedPolice.city} onChange={this.handlePoliceCityChange} />
												</Grid>
												<Grid item xs={1} sm={1}>
												</Grid>
												<Grid item xs={2} sm={2}>
													<TextField required id="zipcode" name="zipcode" label="Zip Code" fullWidth error={this.state.policezipcodeError} helperText={this.state.policezipcodeHelperText} InputLabelProps={{ shrink: this.state.inputFieldShrinkYear }} value={this.state.selectedPolice.zipcode} onChange={this.handlePoliceZipcodeChange} />
												</Grid>
											
											</Grid>  {/* End of Police  form */}
										
										
										< /ExpansionPanelDetails>
									< /ExpansionPanel>}
								
								
								
								
								<Grid item xs={12} sm={12}>
									{/*<br/>
            <br/>*/}
								</Grid>
							</Grid>
							
							<Grid container >
								<Grid item xs={12} sm={12}>
									<Divider className={classes.dividerColor}></Divider>
								</Grid>
							</Grid>
							
							<Grid container spacing={6}>
								<Grid item xs={2} sm={2}>
									{/*<Button variant="contained" color="primary" className={classes.button} disabled={this.state.updateTowButtonDisabled} onClick={(event) => this.handleUpdateTowjob(event)} >
										Update Tow
									</Button>*/}
									{/*  we have an Add Tow Button for it( ((this.state.status == null) || (this.state.status ==undefined)  )|| (this.state.status == 'Unknown') )  && (
										<Button variant="contained" color="primary" onClick={this.handleSubmit} className={classes.button}  >
											Create
										</Button>) */}
									{ ( ((this.state.status != null) && (this.state.status !=undefined)  ) && (this.state.status == 'Waiting') )  && (
										<Button variant="contained" color="primary" onClick={this.handleDisptach} className={classes.button}  >
											Dispatch
										</Button>)}
									{ ( ((this.state.status != null) && (this.state.status !=undefined)  )&& (this.state.status == 'Dispatched') )  && (
										<Button variant="contained" color="primary" onClick={this.handleEnroute} className={classes.button}  >
											En Route
										</Button>)}
									{ ( ((this.state.status != null) && (this.state.status !=undefined) ) && (this.state.status == 'Enroute') )  && (
										<Button variant="contained" color="primary" onClick={this.handleOnscene} className={classes.button}  >
											On Scene
										</Button>)}
									{ ( ((this.state.status != null) && (this.state.status !=undefined)  ) && (this.state.status == 'Onscene') )  && (
										<Button variant="contained" color="primary" onClick={this.handleTowing} className={classes.button}  >
											Towing
										</Button>)}
									{ ( ((this.state.status != null) && (this.state.status !=undefined)  ) && (this.state.status == 'Towing') )  && (
										<Button variant="contained" color="primary" onClick={this.handleCompleted} className={classes.button}  >
											Completed
										</Button>)}
									{ ( ((this.state.status != null) && (this.state.status !=undefined)  ) && (this.state.status == 'Complete') )  && (
										<Button variant="contained" color="primary"  className={classes.button}  >
											No Action
										</Button>)}
								</Grid>
								
								<Grid item xs={2} sm={2}>
									{ ( ((this.state.status == null) || (this.state.status ==undefined)  )|| (this.state.status =="") )  && (
										<Button variant="contained" color="primary" className={classes.button} disabled={this.state.saveTowButtonDisabled} onClick={(event) => this.handleTowJobSubmit(event)} >
											Add Tow
										</Button>)}
								</Grid>
								{/*   I will look at this if I need to have a sperate create police notice.
            <Grid item xs={2} sm={2}>
                <Button variant="contained" color="primary" className={classes.button}  onClick={(event) => this.handleCreatePoliceNotice(event)} >
                Create Notice
            </Button>
            </Grid>
            */}
								
								<Grid item xs={2} sm={2}>
									<Button variant="contained" color="primary" className={classes.button} disabled={this.state.noticeButtonDisabled} onClick={() => this.handleClickShowNotice()}>
										Show Notice
									</Button>
								</Grid>
								
								<Grid item xs={2} sm={2}>
									<Button variant="contained" color="primary" className={classes.button} disabled={this.state.faxButtonDisabled} onClick={() => this.handleClickShowFaxSelect()}>
										Fax
									</Button>
								</Grid>
								<Grid item xs={2} sm={2}>
									<Button variant="contained" color="primary" className={classes.button} disabled={this.state.emailButtonDisabled} onClick={() => this.handleClickShowEmailSelect()}>
										Email
									</Button>
								</Grid>
								<Grid item xs={2} sm={2}>
									<Button variant="contained" color="primary" onClick={this.clearFields} className={classes.button}  >
										Clear Fields
									</Button>
								</Grid>
								
								<Grid item xs={4} sm={4} >
									<FilePicker
										extensions={['jpg']}
										onChange={(FileObject) => {this.handleUploadSelectedFile(FileObject)}}
									>
										<Button variant="contained" color="primary" className={classes.button}  >
											Picture to upload
										</Button>
									
									</FilePicker>
								</Grid>
								<Grid item xs={1} sm={1}>
									{/*
                <Button variant="contained" color="primary" className={classes.button}  onClick={(event) => this.handleFaxSubmit(event)}>
                Fax Police
                </Button>
                */}
									
									<Dialog
										open={this.state.showFaxDialog}
										onClose={this.handleClickShowNoticeClose}
										scroll={'paper'}
										aria-labelledby="scroll-dialog-title"
										aria-describedby="scroll-dialog-description"
									>
										<DialogTitle id="scroll-dialog-title">Police Notice</DialogTitle>
										<DialogContent id="farshids" dividers="paper">
											
											<Document
												file={this.props.policeNoticePath}
												onLoadSuccess={this.onDocumentLoadSuccess} onLoadError={() => { this.setState({ loadError: true }) }}>
												
												<Page scale={1.0} pageNumber={1} />
											</Document>
										</DialogContent>
										<DialogActions>
											{(this.state.loadError == false) &&
												(<Tooltip title="Download to Print notice">
													<Button color="primary" onClick={this.downloadPoliceNoticeFile}>Download</Button>
												</Tooltip>)}
											{/*    file={"http://localhost:8080/files"}     The print was a bit ugly, I am commenting it out for now, unti I have time to invest on it
                <Button onClick={()=>{this.handleClickPrintFax()}} color="primary">Print</Button>
                */}
											<Button onClick={this.handleClickShowNoticeClose} color="secondary">Close</Button>
										</DialogActions>
									</Dialog>
									{/* doing the fax select dialog here. */}
									<Dialog
										open={this.state.showFaxSelectDialog}
										onClose={this.handleClickShowFaxSelectClose}
										scroll={'paper'}
										classes={{
											paper: classes.formControl2,
										}}
										aria-labelledby="scroll-dialog-title"
										aria-describedby="scroll-dialog-description"
										maxWidth="lg"
									>
										<DialogTitle id="scroll-dialog-title">Fax Selection</DialogTitle>
										<DialogContent id="farshids" dividers="paper">
											
											<div>
												Please select the entities you want to fax.
											</div>
											{faxBoxes}
										</DialogContent>
										<DialogActions>
											<Tooltip title="Selected entities will receive police notice">
												<Button color="primary" onClick={this.sendFax}>Send Fax</Button>
											</Tooltip>
											
											<Button onClick={this.handleClickShowFaxSelectClose} color="secondary">Close</Button>
										</DialogActions>
									</Dialog>
									{/* end of fax selection*/}
									
									{/* doing the Email select dialog here. */}
									<Dialog
										open={this.state.showEmailSelectDialog}
										onClose={this.handleClickShowEmailSelectClose}
										scroll={'paper'}
										classes={{
											paper: classes.formControl2,
										}}
										aria-labelledby="scroll-dialog-title"
										aria-describedby="scroll-dialog-description"
										maxWidth="xl"
									>
										<DialogTitle id="scroll-dialog-title">Email  Selection</DialogTitle>
										<DialogContent id="farshids" dividers="paper">
											
											<div>
												Please select the entities you want to email
											</div>
											{emailBoxes}
										</DialogContent>
										<DialogActions>
											<Tooltip title="Selected entities will receive police notice">
												<Button color="primary" onClick={this.sendEmail}>Send EMAIL</Button>
											</Tooltip>
											
											<Button onClick={this.handleClickShowEmailSelectClose} color="secondary">Close</Button>
										</DialogActions>
									</Dialog>
									{/* This is for submit event error/success display */}
									<Dialog
										open={this.state.showTowSavedDialog}
										onClose={this.handleClickShowSavedTowClose}
										scroll={'paper'}
										classes={{
											paper: classes.formControl2,
										}}
										aria-labelledby="scroll-dialog-title"
										aria-describedby="scroll-dialog-description"
										maxWidth="xl"
									>
										<DialogTitle id="scroll-dialog-title">Tow Job action</DialogTitle>
										<DialogContent id="farshids" dividers="paper">
											
											{(this.props.errorCMsg.status == 200) && (<div>
												The Operation was SUCCESSFUL! Please refresh the list by pressing the refresh button -  {this.props.errorCMsg.status}  {this.props.errorCMsg.statusText}
											</div>)}
											{(this.props.errorCMsg.status != 200) && (this.props.errorCMsg.status != null) && (<div>
												The Operation FAILED, please try again! -  {this.props.errorCMsg.status} - {this.props.errorCMsg.statusText}
											</div>)}
										
										</DialogContent>
										<DialogActions>
											{/*
																										<Tooltip title="Selected entities will receive police notice">
																											<Button  color="primary" onClick={this.sendEmail}>Send EMAIL</Button>
																										</Tooltip>
																										*/}
											
											<Button onClick={this.handleClickShowSavedTowClose} color="secondary">Close</Button>
										</DialogActions>
									</Dialog>
									{/* end of Emailselection*/}
								
								
								
								</Grid>
								<Grid item xs={3} sm={3}>
									{/*
                <Button variant="contained" color="primary" className={classes.button}>
                Email Police
            </Button>
            */}
								</Grid>
							
							</Grid> {/* container */}
							
							<Grid container >
								{/*
            <Grid item xs={3} sm={3}>
                <Button variant="contained" color="primary" className={classes.button}>
                    Email Police
                </Button>
            </Grid>
            */}
							
							</Grid> {/* container */}
						
						
						
						
						
						</Grid>
					</Grid>
				
				</Grid>
			
			
			
			
			</React.Fragment>
		);
	}//end of render
	
	
	
	downloadPoliceNoticeFile () {
		var fileName = this.state.selectedVehicle.platenumber+".pdf";
		fetch(this.props.policeNoticePath)
			.then(response => {
				response.blob().then(blob => {
					let url = window.URL.createObjectURL(blob);
					let a = document.createElement('a');
					a.href = url;
					a.download = fileName;
					a.click();
				});
				//window.location.href = response.url;
			});
	}
	
	editRecord(singleRowData){
		//this.setState({inputFieldShrinkYear:true});
		this.setState({ saveTowButtonDisabled: false });
		this.setState({updateTowButtonDisabled:false});
		
		this.extractTheReasonInformationFromTowJob(singleRowData);
		
		/*let tempVehicle={ };
		tempVehicle=
		this.setState({selectedVehicle:singleRowData });
		*/
		
		
		/* for(var i=0; i< this.vehicleCardList.length; {
			if(this.vehicleCardList[i].props.info.id != singleRowData.id ){
																this.vehicleCardList[i].props.info.editMode = true;
			}else{
																this.vehicleCardList[i].props.info.editMode = false;
			}

		}*/
		
		
		
		if(this.setState.alterState == false){
			this.setState({ alterState: true });
		}else{
			this.setState({ alterState: false });
		}
		//We need to change the seleted Location as well.
		//let tempLocation = this.props.locationsArray.find(x => x.locationId == singleRowData.locationId );
		
		//this.setState({selectedLocation:tempLocation });
		
	}
	
	handleEditModeChange(){
		this.setState({ saveTowButtonDisabled: false });
		this.setState({updateTowButtonDisabled:false});
		this.props.onEdit();
		
	}
	
	
	
	deleteRecord(argProcessId){
		//alert('I am deleting ' + argCameraId);
		let {deleteAVehicle} = this.props;
		deleteAVehicle(DEFAULT_VESPAAN_SERVER.url,argProcessId  );
	}
	
	
	componentWillMount(){
		let {loadSingleUserData, loadUsersData, loadVehiclesData, loadPoliceData, loadStoragelotsData,loadLocationsData, loadCompanysData, loadPdfFile,loadCompanypropertysData} = this.props;
		
		
		loadUsersData(DEFAULT_VESPAAN_SERVER.url );
		loadSingleUserData(DEFAULT_VESPAAN_SERVER.url );
		//loadCompanysData(DEFAULT_VESPAAN_SERVER.url );
		/*if(this.props.selectedCompany != null) {
																loadPoliceData(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompany.id);
		}*/
		this.setState({noticeButtonDisabled:false});
		this.setState({faxButtonDisabled:true});
		this.setState({emailButtonDisabled:true});
		
		this.setState({passedTowJob:this.props.passedTowJob});
		/*if(this.props.passedTowJob != null) {
															this.extractThePoliceInformationFromTowJob(this.props.passedTowJob);
		}*/
		
		
		
		/*if((this.props.companysArray != null)  && (this.props.companysArray.length >= 1) ){
																this.setState({ selectedCompany: this.props.companysArray[0] });
		}*/
		this.setState({errorCMsg:{ } });
		
		if((this.props.selectedCompanyInHere !== undefined) && (this.props.selectedCompanyInHere !== null)) {
			loadStoragelotsData(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompanyInHere );
			loadCompanypropertysData(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompanyInHere );
			loadPoliceData(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompanyInHere );
		}
		//loadPdfFile(DEFAULT_VESPAAN_SERVER.url);
		
		//loadPoliceData(DEFAULT_VESPAAN_SERVER.url,event.target.value.id );
		//loadStoragelotsData(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompany.id);
		//loadCompanypropertysData(DEFAULT_VESPAAN_SERVER.url,this.props.selectedCompany.id);
		//selectACompany(event.target.value.id);
		//this.props.changecompany(event.target.value.id);
		//updateAPolicenoticePath(DEFAULT_VESPAAN_SERVER.url,this.props.selectedCompany.id, "79926689-e452-4e60-8c51-85814058eb8e");
		
		
	}
	
	componentDidMount()
	{
		let {loadSingleUserData, loadUsersData, loadVehiclesData, loadPoliceData, loadLocationsData, loadCompanysData,loadStoragelotsData,loadCompanypropertysData} = this.props;
		
		//loadUsersData(DEFAULT_VESPAAN_SERVER.url);
		/*loadSingleUserData(DEFAULT_VESPAAN_SERVER.url );
		loadCompanysData(DEFAULT_VESPAAN_SERVER.url );
		loadPoliceData(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompany.id );*/
		/*if(this.props.passedTowJob != null) {
													this.extractThePoliceInformationFromTowJob(this.props.passedTowJob);
		}*/
		
		if ((this.props.companysArray != null) && (this.props.companysArray.length >= 1)) {
			this.setState({ selectedCompany: this.props.companysArray[0] });
		}
		this.setState({selectedAuthorized: {"name": "me", "phone": "999"}});
		this.setState({errorCMsg: { }});
		let tempPoliceInfo = null;
		
		if ((this.props.passedTowJob != null) && (this.props.passedTowJob != 'undefined')) {
			if (this.props.passedTowJob.reasoncause != null) {
				if ((true)) {
					
					if((this.props.selectedCompanyInHere !== undefined) && (this.props.selectedCompanyInHere !== null)) {
						loadStoragelotsData(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompanyInHere );
						loadCompanypropertysData(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompanyInHere );
						loadPoliceData(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompanyInHere );
					}
					
					
					this.extractTheNoteInformationFromTowJob(this.props.passedTowJob);
					this.extractTheLocationInformationFromTowJob(this.props.passedTowJob);
					tempPoliceInfo = this.extractThePoliceInformationFromTowJob(this.props.passedTowJob);
					this.extractTheStoragelotInformationFromTowJob(this.props.passedTowJob);
					this.extractTheVehicleInformationFromTowJob(this.props.passedTowJob);
					this.extractTheInvoiceInformationFromTowJob(this.props.passedTowJob);
					this.extractTheReasonInformationForTowJob(this.props.passedTowJob);
					this.resetAllErrorsAndErrorTexts();
					//this.setState({noticeButtonDisabled: false});  used to be false I made it true for teh time being 2020/10/4
					this.setState({noticeButtonDisabled: false});
					this.setState({faxButtonDisabled: false});
					this.setState({emailButtonDisabled: false});
					this.setState({towId: this.props.passedTowJob.id});
					this.setState({saveTowButtonDisabled: false});
					this.setState({updateTowButtonDisabled: false});
					updateAPolicenoticePath(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompanyInHere, this.props.passedTowJob.id);
					
					if (this.props.passedTowJob != undefined) {
						var tempPolice = this.getPoliceInfoFromPoliceId(this.props.passedTowJob.policeid);
						this.setState({
							selectedPolice: tempPolice
						});
						
						
						var tempStorage = this.getStoragelotInfoFromStorageId(this.props.passedTowJob.storagelotid);
						this.setState({
							selectedStoragelot: tempStorage
						});
						
						
						
						
						if(this.props.passedTowJob.locationtype == "private") {
							var tempProperty = this.getPropertyInfoFromPropertyId(this.props.passedTowJob.locationid);
							this.setState({
								selectedCompanyProperty: tempProperty
							});
						}else  if(this.props.passedTowJob.locationtype == "public"){
							var tempProperty  = this.getTheLocationInformationFromTowJob(this.props.passedTowJob);
							this.setState({selectedPublicpropertyStateHere:tempLocation});
							//this.setState({usPublicState:tempLocation.state});
							//this.setState({publicCountry:tempLocation.country});
							this.setState({locationtype:tempLocation.type});
							/*this.setState({
								selectedCompanyProperty: tempProperty
							}); */
						}
						
						//var tempAuthorizedPerson = this.getAuthorizedPeopleInfoFromProperty(tempProperty);
						//this.setState({ selectedAuthorized: tempAuthorizedPerson });
						
					}
					/*if(tempPoliceInfo != null)
						this.handlePoliceChange(tempPoliceInfo);*/
					if (tempPoliceInfo != null) {
						
						var evt = document.createEvent('MouseEvents');
						evt.initEvent('mouseup', true, false);
						
						var eventClick = new MouseEvent('click', {
							'view': window,
							'bubbles': true,
							'cancelable': false
						});
						
						
						
						var input = document.getElementById("policeselect");
						//input.selectedIndex = 1;
						//var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
						//nativeInputValueSetter.call(input, tempPoliceInfo.name);
						//let tracker = input._valueTracker;
						//if (tracker) {
						//input._valueTracker.setValue( tempPoliceInfo.departmentname);
						//input._valueTracker.setValue( tempPoliceInfo);
						const lastValue = input.value;
						input.value=tempPoliceInfo;
						var inputEvent = new Event("change", {bubbles: true});
						const tracker = input._valueTracker;
						
						if (tracker) {
							
							tracker.setValue(lastValue);
							
						}
						//input.dispatchEvent(eventClick);
						input.dispatchEvent(inputEvent);
						
						//input.dispatchEvent(evt);
						
						//}
					} //End of if if (tempPoliceInfo != null)
					
					
				}
				
				
			}
		}
		
		
	}
	
	getPoliceInfoFromPoliceId(argPoliceId){
		var returnPolice = null;
		for(var i = 0; i< this.props.policeArray.length; i++){
			if(this.props.policeArray[i].id == argPoliceId){
				returnPolice =  this.props.policeArray[i];
				break;
			}
		}//for
		return returnPolice;
		
	}
	
	getStoragelotInfoFromStorageId(argStorageId){
		var returnPolice = null;
		for(var i = 0; i< this.props.storagelotsArray.length; i++){
			if(this.props.storagelotsArray[i].id == argStorageId){
				returnPolice =  this.props.storagelotsArray[i];
				break;
			}
		}//for
		return returnPolice;
		
	}
	
	getPropertyInfoFromPropertyId(argPropertyId){
		var returnPolice = null;
		for(var i = 0; i< this.props.propertiesArray.length; i++){
			if(this.props.propertiesArray[i].id == argPropertyId){
				returnPolice =  this.props.propertiesArray[i];
				break;
			}
		}//for
		return returnPolice;
		
	}
	
	getTheLocationInformationFromTowJob(argTowJob){
		let returnLocationInfo={};
		if(argTowJob.locationtype=="public") {
			returnLocationInfo.id = argTowJob.locationid;
			returnLocationInfo.name = argTowJob.locationname;
			returnLocationInfo.phone = argTowJob.locationphone;
			returnLocationInfo.fax = argTowJob.locationfax;
			returnLocationInfo.address1 = argTowJob.locationaddress1;
			returnLocationInfo.address2 = argTowJob.locationaddress2;
			returnLocationInfo.city = argTowJob.locationcity;
			returnLocationInfo.state = argTowJob.locationstate;
			returnLocationInfo.country = argTowJob.locationcountry;
			returnLocationInfo.zipcode = argTowJob.locationzipcode;
			returnLocationInfo.email = argTowJob.locationemail;
			returnLocationInfo.type = argTowJob.locationtype;
			returnLocationInfo.locationauthorizedpeople = "";
		}
		return returnLocationInfo;
		
	}
	
	getAuthorizedPeopleInfoFromProperty(argProperty){
		var returnPolice = null;
		if(this.peopleList != null) {
			for (var i = 0; i < this.peopleList; i++) {
				if (this.peopleList[i].email == argProperty.email) {
					returnPolice = this.peopleList[i];
					break;
				}
			}//for
		}
		return returnPolice;
	}
	
	componentWillReceiveProps(nextProps)
	{
		let {loadSingleUserData, loadUsersData, loadVehiclesData, loadPoliceData, loadLocationsData, loadCompanysData, loadPdfFile, loadStoragelotsData,
			loadCompanypropertysData, updateAPolicenoticePath, loadTowEmailsDataWithFilter, loadTowFaxsDataWithFilter} = this.props;
		var tempPoliceInfo= null;
		if((nextProps.passedTowJob != null) && (nextProps.passedTowJob !='undefined')) {
			if (nextProps.passedTowJob.reasoncause != null) {
				
				
				if((this.props.selectedCompanyInHere != nextProps.selectedCompanyInHere !=0)) {
					loadStoragelotsData(DEFAULT_VESPAAN_SERVER.url, nextProps.selectedCompanyInHere);
					
					loadCompanypropertysData(DEFAULT_VESPAAN_SERVER.url, nextProps.selectedCompanyInHere);
					
					
					//selectACompany(event.target.value.id);
					//this.props.changecompany(event.target.value.id);
					loadPoliceData(DEFAULT_VESPAAN_SERVER.url, nextProps.selectedCompanyInHere );
					//loadTowEmailsDataWithFilter(DEFAULT_VESPAAN_SERVER.url, nextProps.selectedCompany, nextProps.passedTowJob.id);
					//loadTowFaxsDataWithFilter(DEFAULT_VESPAAN_SERVER.url, nextProps.selectedCompany, nextProps.passedTowJob.id);
					// This was for testinging passing fixid as string .   updateAPolicenoticePath(DEFAULT_VESPAAN_SERVER.url, nextProps.selectedCompany, "79926689-e452-4e60-8c51-85814058eb8e");
					//updateAPolicenoticePath(DEFAULT_VESPAAN_SERVER.url, nextProps.selectedCompany, nextProps.passedTowJob.id);
					//nextProps.passedTowJob
				}
				if((nextProps.passedTowJob != this.props.passedTowJob)  ) {
					this.extractTheNoteInformationFromTowJob(nextProps.passedTowJob);
					this.extractTheLocationInformationFromTowJob(nextProps.passedTowJob);
					tempPoliceInfo = this.extractThePoliceInformationFromTowJob(nextProps.passedTowJob);
					this.extractTheStoragelotInformationFromTowJob(nextProps.passedTowJob);
					this.extractTheVehicleInformationFromTowJob(nextProps.passedTowJob);
					this.extractTheInvoiceInformationFromTowJob(nextProps.passedTowJob);
					this.extractTheReasonInformationForTowJob(nextProps.passedTowJob);
					this.resetAllErrorsAndErrorTexts();
					//this.setState({noticeButtonDisabled: false});  used to be false I made it true for teh time being 2020/10/4
					this.setState({noticeButtonDisabled: false});
					this.setState({faxButtonDisabled: false});
					this.setState({emailButtonDisabled: false});
					this.setState({towId: nextProps.passedTowJob.id});
					this.setState({saveTowButtonDisabled: false});
					this.setState({updateTowButtonDisabled: false});
					
					
					if (nextProps.passedTowJob != undefined) {
						updateAPolicenoticePath(DEFAULT_VESPAAN_SERVER.url,  nextProps.selectedCompanyInHere, nextProps.passedTowJob.id);
						var tempPolice = this.getPoliceInfoFromPoliceId(nextProps.passedTowJob.policeid);
						this.setState({
							selectedPolice: tempPolice
						});
						
						
						var tempStorage = this.getStoragelotInfoFromStorageId(nextProps.passedTowJob.storagelotid);
						this.setState({
							selectedStoragelot: tempStorage
						});
						
						
						/* var tempProperty = this.getPropertyInfoFromPropertyId(nextProps.passedTowJob.locationid);
						this.setState({
							selectedCompanyProperty: tempProperty
						}); */
						
						if(nextProps.passedTowJob.locationtype == "private") {
							var tempProperty = this.getPropertyInfoFromPropertyId(nextProps.passedTowJob.locationid);
							this.setState({
								selectedCompanyProperty: tempProperty
							});
						}else  if(nextProps.passedTowJob.locationtype == "public"){
							var tempProperty  = this.getTheLocationInformationFromTowJob(nextProps.passedTowJob);
							this.setState({
								selectedPublicpropertyStateHere: tempProperty
							});
							this.setState({locationtype:tempProperty.type});
						}
						
						this.setState({status:nextProps.passedTowJob.status});
						//var tempAuthorizedPerson = this.getAuthorizedPeopleInfoFromProperty(tempProperty);
						//this.setState({ selectedAuthorized: tempAuthorizedPerson });
						
					}
					
					/*if(tempPoliceInfo != null)
						this.handlePoliceChange(tempPoliceInfo);*/
					if(tempPoliceInfo != null) {
						var input = document.getElementById("policeselect");
						//input.selectedIndex = 1;
						//var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
						//nativeInputValueSetter.call(input, tempPoliceInfo.name);
						//let tracker = input._valueTracker;
						//if (tracker) {
						//input._valueTracker.setValue( tempPoliceInfo.departmentname);
						//input._valueTracker.setValue( tempPoliceInfo);
						const lastValue = input.value;
						input.value=tempPoliceInfo;
						var inputEvent = new Event("input", {bubbles: true});
						const tracker = input._valueTracker;
						
						if (tracker) {
							
							tracker.setValue(lastValue);
							
						}
						input.dispatchEvent(inputEvent);
						//}
						
					}
					
					
				}
				
				
			}
		}else {
			if(this.props.saveTowjobResp != null) {
				this.setState({ towId: this.props.saveTowjobResp.id });
			}
			updateAPolicenoticePath(DEFAULT_VESPAAN_SERVER.url,  this.props.selectedCompanyInHere, this.props.saveTowjobResp.id);
			//loadTowEmailsDataWithFilter(DEFAULT_VESPAAN_SERVER.url, nextProps.selectedCompany, this.props.saveTowjobResp.id);
			
		}
		
		if((nextProps.passedTowJob != this.props.passedTowJob)  ) {
			loadTowEmailsDataWithFilter(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompanyInHere, nextProps.passedTowJob.id);
			loadTowFaxsDataWithFilter(DEFAULT_VESPAAN_SERVER.url,this.props.selectedCompanyInHere, nextProps.passedTowJob.id);
			
		}
		
		if((nextProps.pdfFile != null) && (nextProps.pdfFile.length !=0)) {
			//if (nextProps.passedTowJob.reasoncause != null) {
			var fileURL = window.URL.createObjectURL(nextProps.pdfFile);
			window.open(fileURL);
			//}
		}
		
		this.getSelectedCompnayFullInfo();
		if(nextProps.errorCMsg != null) {
			if (nextProps.errorCMsg.status != null) {
				if (nextProps.errorCMsg.status != null) {
					this.handleClickShowSavedTow();
				}
			}
		}
		
		
		
	}
	
	
	
}//end of class

TowForm.propTypes = {
	classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
	return {
		vehiclesArray: state.vehicle.vehiclesArray,
		VehicleDeleteResponse:state.vehicle.deleteVehicleResp,
		selectedCompanyInHere:state.company.selectedCompany,
		VehicleSaveResponse:state.vehicle.saveVehicleResp,
		policeArray: state.police.policeArray,
		PoliceDeleteResponse:state.police.deletePoliceResp,
		PoliceSaveResponse:state.police.savePoliceResp,
		companysArray: state.company.companysArray,
		propertiesArray: state.companyproperty.companypropertysArray,
		storagelotsArray: state.storagelot.storagelotsArray,
		userSaveResponse:state.user.saveUserResp,
		decodedVinVehicleObject: state.vin.decodedVinVehicleObject,
		pdfFile:state.pdf.pdfFile,
		policeNoticePath:state.policenotice.policeNoticePath,
		saveTowjobResp:state.towjob.saveTowjobResp,
		towEmailsArray:state.email.towEmailsArray,
		towFaxsArray:state.fax.towFaxsArray,
		//locationsArray:state.location.locationsArray,
		//vcArray:state.videocontroller.vcArray,
		//camerasArray:state.camera.camerasArray,
		errorCMsg:state.towjob.errorCMsg,
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		loadVehiclesData:loadVehiclesData,
		deleteAVehicle:deleteAVehicle,
		saveAVehicle:saveAVehicle,
		updateAVehicle:updateAVehicle,
		loadPoliceData:loadPoliceData,
		deleteAPolice:deleteAPolice,
		saveAPolice:saveAPolice,
		saveATowjob:saveATowjob,
		updateATowjob:updateATowjob,
		saveAFax:saveAFax,
		saveAEmail:saveAEmail,
		updateAPolice:updateAPolice,
		loadCompanysData:loadCompanysData,
		loadCompanypropertysData:loadCompanypropertysData,
		loadStoragelotsData:loadStoragelotsData,
		loadSingleUserData:loadSingleUserData,
		loadUsersData:loadUsersData,
		loadTowEmailsDataWithFilter:loadTowEmailsDataWithFilter,
		loadTowFaxsDataWithFilter:loadTowFaxsDataWithFilter,
		decodeVin:decodeVin,
		selectACompany:selectACompany,
		loadPdfFile:loadPdfFile,
		saveAPolicenotice:saveAPolicenotice,
		updateAPolicenoticePath:updateAPolicenoticePath,
		clearTowErrorMsg:clearTowErrorMsg,
		uploadATowPicture:uploadATowPicture,
		
	}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TowForm));
